(function () {
    'use strict';
    var controllerId = 'cndPartecipazione';
    angular.module('app').controller(controllerId, ['common', '$scope', '$rootScope', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', 'commonAttach', cndPartecipazione]);

    function cndPartecipazione(common, $scope, $rootScope, bDialog, $routeParams, modal, datacontext, sectionMenu, commonAttach) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        var vm = this;
        vm.title = 'Istanze Inserimento';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);


        vm.objName = "Partecipazione"; //Utilizzato per pannello authorization
        vm.authorization = {};
        vm.risorsa = {};
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.tSourceCode_def = 'PART';

        vm.getRecord = getRecord;
        //vm.getAuthorization = getAuthorization;

        //Elenchi dettaglio
        vm.list = {};
        vm.list.ordine = ['data ricevuta', 'data protocollo', 'ragione sociale', 'codice'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };

        vm.list.attach = [];
        vm.list.b_attach = false;
        vm.list.corsi = [];
        vm.list.corsi_unassigned = [];
        vm.list.tirCateg = [];
        vm.list.partDocenti = [];
        vm.list.partSedi = [];
        vm.list.partAziende = [];
        vm.list.pBudget = [];
        vm.list.partners = [];
        vm.list.partModuli = [];

        //Filtro
        vm.filter = {};

        vm.fTestuale = '';
        vm.fAPLId = 0;
        vm.fTRuoloCode = '';
        vm.fIStato = 0;
        vm.fTAziendaId = 0;
        vm.fType = '';
        vm.fFAM1_TAziendaId = 0;

        vm.filter.testuale = vm.fTestuale;
        vm.filter.aplId = vm.fAPLId;
        vm.filter.tRuoloCode = vm.fTRuoloCode;
        vm.filter.iFinestra = vm.fIFinestra;
        vm.filter.fType = vm.fType;
        vm.filter.tAziendaId = vm.fTAziendaId;
        vm.filter.iStato = vm.fIStato;


        vm.fAttach = {};
        vm.setfAttach = setfAttach;
        vm.filterAttach = '';
        vm.fAttach.TAttachId = '';

        //Elenchi per filtri e finestra modale di Create
        vm.tSource = {};
        vm.tAttach = [];

        vm.cmblist = {};
        vm.cmblist.tMisure = [];
        vm.cmblist.APL = [];
        vm.cmblist.settProfess = [];
        vm.cmblist.paesi = [];
        vm.cmblist.province = [];
        vm.cmblist.provinceSic = [];
        vm.cmblist.tIndirizzi = [];
        vm.cmblist.tProfiloDocenti = [];
        vm.cmblist.tFigProfessionali = [];
        vm.cmblist.tPercorsi = [];
        vm.cmblist.tAziende = [];
        vm.cmblist.tFormaGiuridica = [];
        vm.cmblist.progetti = [];


        vm.cmblist.FORM_Types = jQuery.extend([], datacontext.arrFORM_TAttivita());

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.activated = false;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;

        //infinite scroll per percorsi 2A
        vm.loading_crs = false;
        vm.page_crs = 1;
        vm.countCorsi = 0;

        vm.goNext = goNext;
        vm.goPrev = goPrev;

        //TAB VERTICALI
        vm.setTabShow = setTabShow;

        vm.getListAttach = getListAttach;
        vm.disableCompleted = true;
        vm.changeStateAttach = commonAttach.changeStateAttach;
        vm.extractCADESFile = commonAttach.extractCADESFile;
        vm.extractVerifySignInfo = commonAttach.extractVerifySignInfo;
        vm.safeDownload = commonAttach.safeDownload;

        vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
        vm.merge = mergeItem;
        vm.mergeSuper = mergeSuperItem;
        vm.delete = deleteItem;
        vm.download = downloadItem;
        vm.editDtl = editDtlModal;
        vm.addOrUpdate = addOrUpdateItem;

        vm.showMessage = showMessage;

        //----------------ANOMALIE-------------------------------------
        vm.ableIssue = true;
        vm.ableAddIssue = true;
        vm.setIssue = setIssue;
        vm.unsetIssue = unsetIssue;
        vm.setIssueCPISolved = setIssueCPISolved;
        vm.setIssueAPLSolved = setIssueAPLSolved;

        vm.setPresaIncarico = setPresaIncarico;
        vm.unsetPresaIncarico = unsetPresaIncarico;
        vm.setPresaIncaricoCPI = setPresaIncaricoCPI;
        vm.unsetPresaIncaricoCPI = unsetPresaIncaricoCPI;

        //IssuesLog
        vm.list.issueUMCLog = [];
        vm.list.issueCPILog = [];
        vm.list.issueLog = [];
        vm.addIssueLog = addIssueLog;
        vm.addIssueLogMultiplo = addIssueLogMultiplo;
        vm.getListIssuesLog = getListIssuesLog;
        vm.setIState = setIState;
        vm.deleteIssueLog = deleteIssueLog;

        //stampa anomalie
        vm.printAnomalie = printAnomalie;
        //----------------FINE ANOMALIE--------------------------------



        //datapicker
        vm.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = false;
            vm.opened2 = false;
            if (iOpened == 1) vm.opened1 = true;
            else if (iOpened == 2) vm.opened2 = true;
        };

        vm.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                vm.record.L_DtNasc = '';
                vm.changed = true;
            }
            else if (iOpened == 2) {
                vm.record.FORM_A_Azienda_DDG_dt = '';
                vm.changed = true;
            }
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        vm.change_ruolo = function () {
            //var profiloCode = 'PROM';
            //var tRuoloCode = vm.fTRuoloCode;
            switch (vm.fTRuoloCode) {
                case 'AZD_PROM-LAV1':
                    vm.tSourceCode_def = 'PART_LAV1';
                    break;
                case 'AZD_PROM-FAM1':
                    vm.tSourceCode_def = 'PART_FAM1';
                    break;
                case 'AZD_FORM-LAV1':
                    vm.tSourceCode_def = 'PART_FORM_LAV1';
                    break;
                case 'AZD_FORM-FAM1':
                    vm.tSourceCode_def = 'PART_FORM_FAM1';
                    break;
            }

            vm.filter.tRuoloCode = vm.fTRuoloCode;

            getTSource(vm.tSourceCode_def);
            getTAttach(vm.tSourceCode_def);
            getTFigProfessionali();

            return getAPL(vm.fTRuoloCode);
        };

        // #region Localizzazione - Array

        vm.cmblist.paesi_nasc = [];
        vm.cmblist.province_nasc = [];
        vm.cmblist.comuni_nasc = [];

        vm.cmblist.paesi_lRes = [];
        vm.cmblist.province_lRes = [];
        vm.cmblist.comuni_lRes = [];
        vm.cmblist.tIndirizzi_lRes = [];

        vm.cmblist.paesi_sedeLeg = [];
        vm.cmblist.province_sedeLeg = [];
        vm.cmblist.comuni_sedeLeg = [];
        vm.cmblist.tIndirizzi_sedeLeg = [];

        // #endregion

        // #region Localizzazione Methods        

        //(L_NascPaeseId, L_NascComuneId)
        vm.change_Paesi_Nasc = function () {
            if (vm.record.L_NascPaeseId > 0) {
                vm.record.L_NascComuneId = 0;
                vm.record.L_NascProvinciaId = 0;
            }
        };
        vm.change_Comuni_Nasc = function (idProv) {
            vm.record.L_NascComuneId = '';
            vm.getComuni_Nasc(idProv);
        };
        vm.getComuni_Nasc = function (idprov) {
            if (!idprov || idprov == 0) return vm.cmblist.comuni_nasc = [];
            if (vm.record.L_NascProvinciaId != idprov) vm.cmblist.comuni_nasc = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.comuni_nasc = data;
            });
        };
        vm.getPaesi_Nasc = function () {
            if (vm.cmblist.paesi_nasc.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi_nasc = data;
            });
        };
        vm.getProvince_Nasc = function () {
            if (vm.cmblist.province_nasc.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province_nasc = data;
            });
        };

        //(L_ResPaeseId, L_ResComuneId)
        vm.change_Paesi_LRes = function () {
            if (vm.record.L_ResPaeseId > 0) {
                vm.record.L_ResComuneId = 0;
                vm.record.L_ResProvinciaId = 0;
            }
        };
        vm.change_Comuni_LRes = function (idProv) {
            vm.record.L_ResComuneId = '';
            vm.getComuni_LRes(idProv);
        };
        vm.getComuni_LRes = function (idprov) {
            if (!idprov || idprov == 0) return vm.cmblist.comuni_lRes = [];
            if (vm.record.L_ResProvinciaId != idprov) vm.cmblist.comuni_lRes = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.comuni_lRes = data;
            });
        };
        vm.getPaesi_LRes = function () {
            if (vm.cmblist.paesi_lRes.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi_lRes = data;
            });
        };
        vm.getProvince_LRes = function () {
            if (vm.cmblist.province_lRes.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province_lRes = data;
            });
        };
        vm.getTIndirizzi_LRes = function () {
            if (vm.cmblist.tIndirizzi_lRes.length > 0) return;

            datacontext.tIndirizzo_getAllList().then(function (data) {
                vm.cmblist.tIndirizzi_lRes = data;
            });
        };


        //(SedeLegale_PaeseId, SedeLegale_ComuneId)
        vm.change_Paesi_SedeLeg = function () {
            if (vm.record.SedeLegale_PaeseId > 0) {
                vm.record.SedeLegale_ComuneId = 0;
                vm.record.SedeLegale_ProvinciaId = 0;
            }
        };
        vm.change_Comuni_SedeLeg = function (idProv) {
            vm.record.SedeLegale_ComuneId = '';
            vm.getComuni_SedeLeg(idProv);
        };
        vm.getComuni_SedeLeg = function (idprov) {
            if (!idprov || idprov == 0) return vm.cmblist.comuni_sedeLeg = [];
            if (vm.record.SedeLegale_ProvinciaId != idprov) vm.cmblist.comuni_sedeLeg = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.comuni_sedeLeg = data;
            });
        };
        vm.getPaesi_SedeLeg = function () {
            if (vm.cmblist.paesi_sedeLeg.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi_sedeLeg = data;
            });
        };
        vm.getProvince_SedeLeg = function () {
            if (vm.cmblist.province_sedeLeg.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province_sedeLeg = data;
            });
        };
        vm.getTIndirizzi_SedeLeg = function () {
            if (vm.cmblist.tIndirizzi_sedeLeg.length > 0) return;

            datacontext.tIndirizzo_getAllList().then(function (data) {
                vm.cmblist.tIndirizzi_sedeLeg = data;
            });
        };

        // #endregion

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [
                getAuthorization()
                , getTMisure()
                , getTRuoli()
                , getSettProfess()
                , getTFormaGiuridica()
                , getPaesi()
                , getProvince()
                , getProvinceSic()
                , getTIndirizzi()
                , getTProfiliDocenti()
                , getTPercorsi()
                , getTAziende()
                , getProgetti()
                //Localizzazioni
                , vm.getPaesi_Nasc()
                , vm.getProvince_Nasc()
                , vm.getPaesi_LRes()
                , vm.getProvince_LRes()
                , vm.getTIndirizzi_LRes()
                , vm.getPaesi_SedeLeg()
                , vm.getProvince_SedeLeg()
                , vm.getTIndirizzi_SedeLeg()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    vm.activated = true;

                    if ($routeParams.TRuoloCode != null) {
                        vm.fTRuoloCode = $routeParams.TRuoloCode;
                        switch (vm.fTRuoloCode) {
                            case 'AZD_PROM-LAV1':
                                vm.title += ' GOL - Avviso Percorso 1,2,3,5';
                                //vm.addDisabled = true;
                                break;
                            case 'AZD_PROM-FAM1':
                                vm.title += ' GOL - Avviso Percorso 4';
                                //vm.addDisabled = true;
                                break;
                            case 'AZD_FORM-LAV1':
                                vm.title += ' GOL - Avviso Formazione Percorso 5';
                                //vm.addDisabled = true;
                                break;
                            case 'AZD_FORM-FAM1':
                                vm.title += ' GOL - Avviso Formazione Percorso 4';
                                //vm.addDisabled = true;
                                break;
                        }
                    }

                    vm.change_ruolo(); //Carico le apl in base alla misura 


                    if ($routeParams.CNDPartecipazioneId != null) {
                        setView('detail');
                        return getRecord($routeParams.CNDPartecipazioneId, 0);
                    }

                    cerca();
                });
        }


        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;

            vm.filter.testuale = vm.fTestuale == null ? '' : vm.fTestuale;
            vm.filter.aplId = vm.fAPLId == null ? 0 : vm.fAPLId;
            vm.filter.tRuoloCode = vm.fTRuoloCode == null ? '' : vm.fTRuoloCode;
            vm.filter.iFinestra = vm.fIFinestra == null ? 0 : vm.fIFinestra;
            vm.filter.tAziendaId = vm.fTAziendaId == null ? 0 : vm.fTAziendaId;
            vm.filter.fType = vm.fType == null ? '' : vm.fType;
            vm.filter.iStato = vm.fIStato == null ? 0 : vm.fIStato;

            //console.info('tRuoloCode', vm.filter.tRuoloCode, vm.fTRuoloCode);

            vm.loading = false;

            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.partecipazione_countAll(vm.filter.testuale, vm.filter.aplId, vm.filter.tRuoloCode, vm.filter.iFinestra, vm.filter.tAziendaId, vm.filter.fType, vm.filter.iStato).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (!vm.activated) return;
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;

            return datacontext.partecipazione_getAll(vm.pageSize, vm.page, vm.filter.testuale, vm.filter.aplId, vm.filter.tRuoloCode, vm.filter.iFinestra, vm.filter.tAziendaId, vm.filter.fType, vm.filter.iStato, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getAuthorization() {
            return $rootScope.getAuthorization(vm, vm.objName).then(function () {
                //Auth. specifica
                vm.iTags_16384 = vm.isSUPER || (vm.authorization.iTags & 16384) == 16384;

                vm.iTags_64 = !vm.isSUPER && (vm.authorization.iTags & 64) == 64;

                //vm.isSpecial = (vm.isSUPER || vm.isIstruttore || vm.isCIAPI);
                if (vm.isUMC || vm.isIstruttore || vm.isFAM) {
                    //Di Default "Con ricevuta"
                    vm.fIStato = 4;
                }
                vm.bClona = vm.isSUPER; //vm.isAPL || vm.isSUPER;

                $rootScope.getRisorsa(vm);
            });
        }

        function setRecord(data) {
            //console.info('setRecord()', data);
            vm.record = data;

            vm.showWF = false;

            if (vm.record.RUNTS_Dt != null) vm.record.RUNTS_Dt = new Date(vm.record.RUNTS_Dt);
            if (vm.record.L_RuoloDt != null) vm.record.L_RuoloDt = new Date(vm.record.L_RuoloDt);
            if (vm.record.L_DtNasc != null) vm.record.L_DtNasc = new Date(vm.record.L_DtNasc);
            if (vm.record.FORM_A_Azienda_DDG_dt != null) vm.record.FORM_A_Azienda_DDG_dt = new Date(vm.record.FORM_A_Azienda_DDG_dt);
            //CountDown            
            if (vm.record.ShowCountdown) {
                vm.targetDate = new Date(vm.record.CountdownDtEnd);
                vm.targetDateString = vm.targetDate.toISOString();
                vm.textFinished = 'Termini scaduti';
                vm.textSuccess = 'Presentato nei termini';
            }

            //Azzera liste
            vm.list.attach = [];
            vm.list.b_attach = false;

            //Azzera filtri
            vm.filterAttach = '';
            vm.fAttach.TAttachId = '';
            vm.filterProvince = null;

            vm.RecIssueAPL = false; // vm.record.IssueAPL; richiesta dalla dott.ssa Serrao

            vm.showDtScad = false;
            vm.showAttIBAN = true;
            switch (vm.record.TRuoloCode) {
                case 'AZD_PROM-LAV1':
                    vm.getPartSedi(vm.record.Id);
                    if (vm.record.Sent) {
                        vm.getSediAccr();
                    }                    
                    break;                
                case 'AZD_PROM-FAM1':
                    vm.record.TRuoloCodePartners = 'AZD_PRTN-FAM1';
                    getPartners();
                    vm.getPartSedi(vm.record.Id);
                    if (vm.record.Sent) {
                        vm.getSediAccr();
                    }
                    vm.getPartAziende();
                    vm.getPBudget();
                    vm.showDtScad = true;
                    vm.showAttIBAN = false;
                    break;
                case 'AZD_FORM-LAV1':
                    vm.validIBAN = true;
                    vm.checkIBAN();
                    vm.getPartSedi(vm.record.Id);
                    vm.getPartModulo();
                    break;
                case 'AZD_FORM-FAM1':
                    vm.getPartSedi(vm.record.Id);
                    vm.getPartModulo();
                    vm.showDtScad = true;
                    vm.showAttIBAN = false;
                    break;
            }

            vm.getComuni_Nasc(vm.record.L_NascProvinciaId);
            vm.getComuni_LRes(vm.record.L_ResProvinciaId);
            vm.getComuni_SedeLeg(vm.record.SedeLegale_ProvinciaId);

            getListAttach(vm.record.Id);
            vm.records[vm.index] = vm.record;

            setTabShow();
        }

        function getRecord(id, index) {
            return datacontext.partecipazione_get(id).then(function (data) {
                console.info('getRecord', data);
                vm.index = index;
                setRecord(data);
                setView('detail');
            });
        }

        function goNext() {
            if (vm.index + 1 >= vm.countRecords) return;
            if (vm.index + 1 >= vm.records.length && vm.index + 1 < vm.countRecords) {
                getByFilter();
            }
            if (!vm.records) return;

            vm.index++;
            return getRecord(vm.records[vm.index].Id, vm.index);
        }

        function goPrev() {
            if (vm.index == 0) return;
            if (!vm.records) return;

            vm.index--;

            return getRecord(vm.records[vm.index].Id, vm.index);
        }


        function addRecord(id) {
            return datacontext.partecipazione_get(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
            });
        }


        function updateItem() {
            return datacontext.partecipazione_update(vm.record).then(function (data) {
                console.info('updateItem()', data);
                if ($.isNumeric(data)) {
                    if (data < 0) return parseInt(data); //Resistuisco un numero perch� il metodo � chiamato nelle variazioni di stato
                    else if (data == "406") return bDialog.errorDialog('Attenzione: inserire tutti gli allegati richiesti, per ogni area di pertinenza dell\'Avviso. ');
                    else if (data == "417") return bDialog.errorDialog('Attenzione: il termine di presentazione delle istanze \xE8 scaduto.');
                }

                setRecord(data);
                vm.records[vm.index] = vm.record;

                return logSuccess('Record Salvato ');
            });
        }

        function mergeItem(completed) {
            console.log(completed);
            return datacontext.partecipazione_merge(vm.record).then(function (data) {
                console.info('mergeItem($s)', completed, data);
                var status = $.isNumeric(data) ? data : data.status;
                var error = $.isNumeric(data) ? '' : data.data;

                if ($.isNumeric(status)) {
                    if (completed == 1) vm.record.Completed = false;
                    //console.info('status', status);
                    if (status < 0) return parseInt(status); //Resistuisco un numero perch� il metodo � chiamato nelle variazioni di stato
                    if (status == "409") {
                        return bDialog.informationDialog('Attenzione, non hai coperto i seguenti territori: ' + error);
                    } else if (status == "417") {
                        return bDialog.errorDialog('Attenzione: il termine di presentazione delle istanze \xE8 scaduto.');
                    }
                    else {
                        return bDialog.errorDialog('Attenzione: errore generico.');
                    }
                }

                setRecord(data);

                return logSuccess('Record Salvato ');
            });
        }

        function mergeSuperItem() {
            return datacontext.partecipazione_mergeSuper(vm.record).then(function (data) {
                console.info('mergeSuperItem()',  data);
                var status = $.isNumeric(data) ? data : data.status;
                var error = $.isNumeric(data) ? '' : data.data;

                if ($.isNumeric(status)) {
                    if (completed == 1) vm.record.Completed = false;
                    //console.info('status', status);
                    if (status < 0) return parseInt(status); //Resistuisco un numero perch� il metodo � chiamato nelle variazioni di stato
                    if (status == "409") {
                        return bDialog.informationDialog('Attenzione, non hai coperto i seguenti territori: ' + error);
                    } else if (status == "417") {
                        return bDialog.errorDialog('Attenzione: il termine di presentazione delle istanze \xE8 scaduto.');
                    }
                    else {
                        return bDialog.errorDialog('Attenzione: errore generico.');
                    }
                }

                setRecord(data);

                return logSuccess('Record Salvato ');
            });
        }

        function deleteItem(item) {
            var msg = ' Istanza ID: ' + item.Id;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.partecipazione_delete(item.Id).then(function (data) {
                    if (data != "204") return bDialog.errorDialog('Errore cancellazione dati');

                    var index = vm.records.indexOf(item);
                    vm.records.splice(index, 1);
                    vm.countRecords--;

                    return logSuccess('Record cancellato ');
                });
            });
        }

        function downloadItem(item) {
            $('#loadingModal').modal('show');
            return datacontext.attach_download(item.Id, vm.tSourceCode_def, 0, 0).then(function (data) {
                $('#loadingModal').modal('hide');
                if (data == '') return bDialog.errorDialog('Documentazione non disponibile.');
                var url = data;
                window.open(url, 'Download');
            });
        }

        vm.setProtSent = function (item, index) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPartecipazione/modal/cndPartecipProtSent.html?version=127',
                controller: 'cndPartecipProtSent',
                backdrop: 'static',
                resolve: {
                    partecipazione: function () {
                        return item;
                    },
                    isSuper: function () {
                        return vm.isSpecial;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                //console.info('returnItem', returnItem);
                if (!returnItem) return bDialog.errorDialog('Errore. ');
                setRecord(returnItem);
                vm.records[vm.index] = vm.record;
                logSuccess('Istanza protocollata con successo! ');
            }, function () {
                //
            });
        };

        vm.unsetProtSent = function (item, index) {
            if (item.NumProtSent != null && item.NumProtSent != "") {
                bDialog.confirmationDialog('RIMOZIONE PROTOCOLLO', 'Si sta rimuovendo il protocollo dell\'istanza. Proseguire?', 'OK').then(
                    function () { //YES
                        return datacontext.partecipazione_unsetProtSent(item).then(function (data) {
                            if (data == '404') return bDialog.errorDialog('Errore di aggiornamento stato. ');
                            if (typeof data == 'undefined') return bDialog.errorDialog('Errore. ');
                            setRecord(data);
                            vm.records[vm.index] = vm.record;
                            return true;
                        });
                    },
                    function () { //NO

                    }
                );
            }
        };

        vm.setConvalida = function (item, index) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPartecipazione/modal/cndPartecipConvalida.html?version=127',
                controller: 'cndPartecipConvalida',
                backdrop: 'static',
                resolve: {
                    partecipazione: function () {
                        return item;
                    },
                    tRuoloCode: function () {
                        return item.TRuoloCode;
                    },
                    pSedi: function () {
                        return vm.list.partSedi;
                    },
                    isSuper: function () {
                        return vm.isSpecial;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == '400') return bDialog.errorDialog('Errore Aggiornamento');
                if (!returnItem) return bDialog.errorDialog('Errore. ');
                setRecord(returnItem);
                vm.records[vm.index] = vm.record;
                logSuccess('Istanza convalidata con successo! ');
            }, function () {
                //
            });
        };

        vm.unsetConvalida = function (item, index) {
            if (item.iConvalida != 0) {
                bDialog.confirmationDialog('RIMOZIONE CONVALIDA', 'Si sta rimuovendo la convalida dall\'istanza. Proseguire?', 'OK').then(
                    function () { //YES
                        item.iConvalida = 0;
                        return datacontext.partecipazione_unsetConvalida(item).then(function (data) {
                            if (typeof data == 'undefined') return bDialog.errorDialog('Errore. ');
                            setRecord(data);
                            vm.records[vm.index] = vm.record;
                            return true;
                        });
                    },
                    function () { //NO

                    }
                );
            }
        };

        vm.partecipInfoEditAmmiss = function (item, index) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPartecipazione/modal/cndPartecipInfoEditAmmiss.html?version=127',
                controller: 'cndPartecipInfoEditAmmiss',
                backdrop: 'static',
                resolve: {
                    partecipazione: function () {
                        return item;
                    },
                    isSuper: function () {
                        return vm.isSpecial;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == '400') return bDialog.errorDialog('Errore Aggiornamento');
                if (!returnItem) return bDialog.errorDialog('Errore. ');
                setRecord(returnItem);
                vm.records[vm.index] = vm.record;
                logSuccess('Note aggiornate! ');
            }, function () {
                //
            });
        };



        vm.setCompleted = function () {
            switch (vm.fTRuoloCode) {
                case 'AZD_PROM-LAV1':
                    if (vm.list.partSedi.length == 0) {
                        return bDialog.errorDialog('Non \xE8 stata inserita alcuna sede. Inserirne almeno una.');
                    }
                    fn_setCompleted();
                    break;                
                case 'AZD_PROM-FAM1':
                    if (vm.record.FAM1_TAziendaId > 1) {
                        if (vm.list.partAziende.length == 0) {
                            return bDialog.errorDialog('Non \xE8 stato inserito alcun partner. Inserirne almeno uno.');
                        }
                        else if (vm.list.pBudget.length == 0) {
                            return bDialog.errorDialog('Non \xE8 stato inserito alcun budget. Inserirne almeno uno.');
                        }
                    }
                    if (vm.list.partSedi.length == 0) {
                        return bDialog.errorDialog('Non \xE8 stata inserita alcuna sede. Inserirne almeno una.');
                    }
                    fn_setCompleted();
                    break;
                case 'AZD_FORM-LAV1':
                    if (vm.record.FORM_Type == 'B' && vm.list.partSedi.length == 0) {
                        return bDialog.errorDialog('Non \xE8 stata inserita alcuna sede. Inserirne almeno una.');
                    }
                    if (vm.record.FORM_Type=='A' && vm.list.partModuli.length == 0) {
                        return bDialog.errorDialog('Non \xE8 stata inserita alcun modulo. Inserirne almeno uno.');
                    }
                    if (vm.record.FORM_Type == 'A' && (vm.record.FORM_A_Azienda_DDG_n == null || vm.record.FORM_A_Azienda_DDG_n.length == 0
                        || vm.record.FORM_A_Azienda_DDG_dt == null || vm.record.FORM_A_Azienda_DDG_dt.length == 0
                        || vm.record.FORM_A_Azienda_Nome == null || vm.record.FORM_A_Azienda_Nome.length == 0
                        || vm.record.FORM_A_Azienda_Indirizzo == null || vm.record.FORM_A_Azienda_Indirizzo.length == 0 
                        || vm.record.FORM_A_Azienda_nLav == null || vm.record.FORM_A_Azienda_nLav.length == 0)) {
                        return bDialog.errorDialog('Bisogna compilare la scheda "AZIENDA".');
                    }
                    fn_setCompleted();

                    break;
                case 'AZD_FORM-FAM1':
                    if (vm.list.partSedi.length == 0) {
                        return bDialog.errorDialog('Non \xE8 stata inserita alcuna sede. Inserirne almeno una.');
                    }
                    if (vm.list.partModuli.length==0) {
                        return bDialog.errorDialog('Non \xE8 stata inserita alcun modulo. Inserirne almeno uno.');
                    }
                    if (vm.PartModuli_TotOre == 0 || vm.PartModuli_TotOre > 56) {
                        return bDialog.errorDialog('Ore massime consentite 56.');
                    }
                    if (vm.record.FORM_Referente_Ufficio == null || vm.record.FORM_Referente_Ufficio.length == 0
                        || vm.record.FORM_Referente_Nominativo == null || vm.record.FORM_Referente_Nominativo.length == 0
                        || vm.record.FORM_Referente_Tel == null || vm.record.FORM_Referente_Tel.length == 0
                        || vm.record.FORM_Referente_Email == null || vm.record.FORM_Referente_Email.length == 0) {
                        return bDialog.errorDialog('Bisogna compilare la scheda "REFERENTE".');
                    }
                    
                    fn_setCompleted();

                    break;
            }
        };

        vm.setCompletedSedi = function () {
            if (vm.list.partSedi.length == 0) {
                return bDialog.errorDialog('Non \xE8 stata inserita alcuna sede. Inserirne almeno una.');
            }

            var msg = 'Attenzione, dopo la "CONVALIDA SEDI" non sar\xE0 possibile apportare modifiche alle sedi dell\'Istanza. Si desidera proseguire?';
            bDialog.confirmationDialog('CONVALIDA SEDI', msg, 'Ok').then(
                function () { //YES
                    return datacontext.partecipazione_convalidaSedi(vm.record).then(function (data) {
                        var status = data.status
                        var error = data.data;

                        if ($.isNumeric(status)) {
                            if (status < 0) return parseInt(status); //Resistuisco un numero perch� il metodo � chiamato nelle variazioni di stato
                            if (status == "409") {
                                return bDialog.informationDialog('Attenzione, non hai coperto i seguenti territori: ' + error);
                            }
                            else {
                                return bDialog.errorDialog('Attenzione: errore generico.');
                            }
                        }

                        setRecord(data);
                        vm.records[vm.index] = vm.record;

                        return logSuccess('Record Salvato ');
                    });
                },
                function () { //NO
                    //
                }
            );
        };

        function fn_setCompleted() {
            if (!vm.record.Completed) {
                var msg = 'Attenzione, dopo la "CONVALIDA" non sar\xE0 possibile apportare modifiche all\'istanza. Si desidera proseguire?';
                bDialog.confirmationDialog('SALVA E CONVALIDA', msg, 'Ok').then(
                    function () { //YES
                        vm.record.Completed = true;
                        mergeItem(1).then(function (data) {
                            console.info('fn_setCompleted()', data);
                            if (typeof data == undefined || $.isNumeric(data)) {
                                vm.record.Completed = false;
                                if ($.isNumeric(data)) {
                                    var msg = 'Attenzione, si \xE8 verificato un errore che ha impedito il salvataggio, ';
                                    switch (data) {
                                        case -1:
                                            msg += '\xE8 necessario inserire almeno un catalogo formativo. ';
                                            break;
                                        case -2:
                                            msg += '\xE8 necessario inserire almeno una sede delle attivt\xE0.';
                                            break;
                                        case -3:
                                            msg += '\xE8 necessario inserire almeno un docente. ';
                                            break;
                                        case -4:
                                            msg += '\xE8 necessario inserire almeno un settore professionale. ';
                                            break;
                                        case -5:
                                            msg += '\xE8 necessario inserire una sede accreditata per il territorio siciliano. ';
                                            break;
                                        case -6:
                                            msg += 'premesso che "TotTir" sia il numero totale di tirocini, l\'importo della sovvenzione richiesta deve essere compreso tra un minimo di (200 x TotTir) ed un massimo di (500 x TotTir). ';
                                            break;
                                        case -7:
                                            msg += 'la somma del numero di tirocini inseriti nei settori professionali non corrisponde al numero totale di tirocini. ';
                                            break;
                                        case -8:
                                            msg += '\xE8 necessario inserire almeno un percorso formativo. ';
                                            break;
                                        case -9:
                                            msg += 'il numero di allievi inserito non rispetta i vincoli dell\'Avviso. ';
                                            break;
                                        case -10:
                                            msg += '\xE8 necessario inserire almeno un modulo formativo. ';
                                            break;
                                        case -11:
                                            msg += '\xE8 necessario inserire i moduli obbligatori: "Igiene e sicurezza su luogo di lavoro" e "Competenza digitale trasversale n.4".';
                                            break;
                                        case -12:
                                            msg += 'verificare che per ogni competenza siano garantite tutte le abilit\xE0 minime e le conoscenze essenziali previste.';
                                            break;
                                        case -13:
                                            msg += '\xE8 consentito inserire max 4 competenze.';
                                            break;
                                        case -15:
                                            msg += '\xE8 necessario compilare tutti i campi obbligatori della propria "SCHEDA ENTE" (sezione "RUBRICHE" e per convalidare si prema "SALVA E CONVALIDA DATI"). Poich\xE8 essi sono parte integrante degli allegati generati dal sistema.';
                                            break;
                                        default:
                                            msg = 'Attenzione, si \xE8 verificato un errore che ha impedito il salvataggio. ';
                                            break;
                                    }
                                    return bDialog.informationDialog(msg);
                                }
                            }
                        });
                    },
                    function () { //NO
                        //
                    }
                );
            }




        }

        vm.unlock = function (item) {
            item = vm.record;
            var msg = 'Istanza ' + item.Id;
            bDialog.confirmationDialog('SBLOCCO ISTANZA', 'Sei sicuro di voler sbloccare l\'' + msg + ' ?', 'OK').then(
                function () { //YES
                    return datacontext.partecipazione_unlock(item).then(function (data) {
                        if (data != "204") return bDialog.errorDialog('Errore: operazione non consentita');
                        vm.record.Completed = false;
                        vm.getPBudget();
                    });
                },
                function () { //NO
                    //vm.record.Completed = false;
                }
            );
        };


        vm.setSent = function () {
            if (!vm.record.Sent) {
                if (vm.record.TRuoloCode == 'AZD_PROM-FAM1' && vm.record.FAM1_TAziendaId > 1) {
                    var tAttachCode = 'FAM1_5';
                    var allegato4 = _.find(vm.list.attach, function (o) { return o.TAttachCode == tAttachCode; });
                    var tAttachCode6 = 'FAM1_6';
                    var allegato6 = _.find(vm.list.attach, function (o) { return o.TAttachCode == tAttachCode6; });
                    //console.info('vm.setSent', allegato4, allegato6);
                    if (allegato4 == undefined && allegato6 == undefined) {
                        var msg = 'Attenzione, non \xE8 stato inserito uno tra l\'allegato 4 e lo statuto. Procedere per la generazione della ricevuta? ';
                        bDialog.confirmationDialog('INFO ALLEGATI', msg, 'Procedi').then(
                            function () { //YES
                                fn_setSent();
                            }, function () { //NO

                            });
                    } else {
                        fn_setSent();
                    }
                }
                else {
                    fn_setSent();
                }
            }
            else {
                vm.printRicevuta();
            }
        };

        function fn_setSent() {
            var msg = 'La stampa della "Ricevuta" equivale a dichiarare terminata tutta la procedura telematica; pertanto non sar\xE0 possibile modificare o caricare altri documenti. Procedere?';
            bDialog.confirmationDialog('GENERA RICEVUTA', msg, 'Procedi').then(
                function () { //YES
                    vm.record.Sent = true;
                    vm.loading = true;
                    return datacontext.partecipazione_setSent(vm.record.Id).then(function (data) {
                        //console.info('setSent()', data);
                        var status = data.status
                        var error = data.data;
                        vm.loading = false;
                        if ($.isNumeric(status) || typeof data == 'undefined') {
                            vm.record.Sent = false;
                            if (status == 400) return 400;
                            else if (status == 406) {
                                var msg = error;
                                if (vm.record.TRuoloCode == 'AZD_PROM-LAV1') {
                                    if (error.includes('PART_LAV1'))
                                        msg = error.replace('PART_LAV1', 'istanza corrente');
                                }

                                logError(msg);
                                return bDialog.informationDialog(msg);
                            }
                            else if (status == 409) {
                                return bDialog.informationDialog('Attenzione, le sedi inserite non coprono i seguenti territori: ' + error);
                            }
                            else if (status == 417) return bDialog.errorDialog('Attenzione: il termine di presentazione delle istanze \xE8 scaduto.');
                            else if (status == 502)
                                return bDialog.errorDialog('Attenzione: la stampa della "ricevuta" non \xE8 ancora permessa, in quanto non \xE8 il periodo utile.');

                            return true;
                        } else {
                            vm.printRicevuta();
                        }
                        getRecord(vm.record.Id, vm.index);
                        return true;
                    });
                },
                function () { //NO
                    vm.loading = false;
                }
            );
        }

        vm.unlockSent = function () {
            if (vm.record.Sent) {
                bDialog.confirmationDialog('RIMOZIONE RICEVUTA', 'Si vuole rimuovere lo stato in "Ricevuta". Ma l\'assegnazione del codice rimmarr\xE0 a sistema. Procedere?', 'SI').then(
                    function () { //YES
                        return datacontext.partecipazione_unlockSent(vm.record).then(function (data) {
                            if (data != "204") return bDialog.errorDialog('Errore: operazione non consentita');
                            vm.record.Sent = false;
                            vm.records[vm.index].Sent = vm.record.Sent;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            }
        };

        vm.clona = function (item) {
            if (vm.isSUPER && item.Sent) {
                bDialog.confirmationDialog('CLONAZIONE ISTANZA', 'Si vuole clonare l\'istanza. Procedere?', 'SI').then(
                    function () { //YES
                        return datacontext.partecipazione_clona(item.Id).then(function () {
                            //vm.bClona = vm.isAPL ? false : vm.bClona;
                            cerca();
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            }
        }

        vm.createConvenzione = function (item) {
            console.info('createConvenzione()', item);
            if (vm.isSUPER && item.Sent) {
                bDialog.confirmationDialog('GENERA CONVENZIONE', 'Si sta per generare la convenzione dell\'istanza. Si noti che se la convenzione esiste gi\xE0, viene aggiunta "IN ADDENDUM". Procedere?', 'SI').then(
                    function () { //YES
                        return datacontext.cndConvenzione_create(item.TRuoloCode, item.Id, false).then(function (data) {
                            if (data == 1) return logSuccess('Convenzione creata con successo');
                            else return logError('Errore, si \xE8 verificato un imprevisto oppure utente non autorizzato');
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            }
        }

        vm.setAnnulled = function (item, index, locked) { //Se locked==true => 'Annullo' l'istanza; altrimenti la 'Riabilito'
            if (item != null && item.Id > 0) {
                var msg = 'Stai per annullare l\'istanza ' + item.NomeCorso + '. Procedere?';
                if (!locked) msg = 'Stai per riabilitare l\'istanza ' + item.NomeCorso + '. Procedere?';
                bDialog.confirmationDialog('ANNULLAMENTO ISTANZA', msg, 'OK').then(
                    function () { //YES
                        return datacontext.partecipazione_setAnnulled(item.Id, locked).then(function (data) {
                            if (data == "304") {
                                return bDialog.errorDialog('Errore sul "setAnnulled". ');
                            }
                            else {
                                vm.records[vm.index].Annulled = locked;
                                return logSuccess('Record modificato. ');
                            }
                        });
                    },
                    function () { //NO
                        //
                    }
                );
            }
        };

        vm.modalAnnulled = function (item, index) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPartecipazione/modal/cndPartecipAnnulled.html?version=127',
                controller: 'cndPartecipAnnulled',
                backdrop: 'static',
                resolve: {
                    partecipazione: function () {
                        return item;
                    }
                }
            });
            modalInstance.result.then(function (returnItem) {
                if (returnItem == "304") return bDialog.errorDialog('Errore: operazione non consentita');
                vm.records[vm.index].Annulled = true;
            }, function () {
                vm.records[vm.index].Annulled = false;
            });
        };


        //*************************
        vm.setImporto = function () {
            if (vm.record.M2C_NumDest > 0) {
                var UCS_2C = 4000;
                vm.record.M2C_Importo = parseFloat(UCS_2C * vm.record.M2C_NumDest);
            }
        };

        // #region Print ALLEGATI

        vm.DownloadAllegato = function (url) {
            window.open(url, '_blank');
        }

        vm.printAllegato = function (codeAttach, corsoId, pAziendaId) {
            if (typeof corsoId == 'undefined' || corsoId == null || corsoId == '')
                corsoId = 0;
            if (typeof pAziendaId == 'undefined' || pAziendaId == null || pAziendaId == '')
                pAziendaId = 0;
            var msg = '';
            var nomeAllegato = '';

            if (!vm.record.Completed) {
                msg = 'L\'allegato ' + nomeAllegato + ' verr\xE0 stampato (in formato PDF) in bozza. Procedere? ';
            }
            else {
                msg = 'L\'allegato ' + nomeAllegato + ' verr\xE0 stampato (in formato PDF). Procedere? ';
            }
            bDialog.confirmationDialog('STAMPA IN FORMATO PDF', msg, 'OK').then(
                function () { //YES
                    vm.printing = true;
                    $('#loadingModal').modal('show');

                    return datacontext.pdf_printAttach2(0, vm.tSourceCode_def, vm.record.Id, corsoId, codeAttach, pAziendaId).then(function (response) {
                        vm.printing = false;
                        $('#loadingModal').modal('hide');
                        var status = response.status;
                        var data = response.data;

                        if (response == null || $.isNumeric(status)) {
                            if (status == 417) {
                                return bDialog.errorDialog('Attenzione si \xE8 verificato il seguente problema: ' + data);
                            }
                            if (status == 400) {
                                return bDialog.errorDialog('Attenzione compilare tutti i campi della Scheda Ente');
                            }
                            return bDialog.errorDialog('Attenzione si \xE8 verificato un problema durante la generazione dell\'allegato. ');
                        }
                        else if (response && response.url) {

                            var url = response.url;
                            var name = 'Allegato_' + codeAttach + '_ID' + vm.record.Id + '_' + vm.record.APL + '.pdf';


                            window.open(url, name);

                            //recupero allegato appena creato
                            //var a = document.createElement("a");
                            //a.setAttribute('style', 'display:none');
                            //a.setAttribute('target', '_blank');
                            //document.body.appendChild(a);

                            //a.href = response.url;
                            //if ($rootScope.detectIE()) {
                            //    a.target = 'hiddenIframe';
                            //}
                            //else
                            //    a.download = name;
                            //a.click();
                            //document.body.removeChild(a);

                            return response.url;
                        } else
                            return true;
                    });
                },
                function () { //NO
                    //
                }
            );
        };

        vm.printRicevuta = function () {
            if (vm.record.Sent) {
                $('#loadingModal').modal('show');

                return datacontext.pdf_printRicevuta2(0, vm.tSourceCode_def, vm.record.Id).then(function (response) {
                    $('#loadingModal').modal('hide');
                    var status = response.status;
                    var data = response.data;

                    if (response == null || $.isNumeric(status)) {
                        if (status == 417) {
                            return bDialog.errorDialog('Attenzione si \xE8 verificato il seguente problema: ' + data);
                        }
                        return bDialog.errorDialog('Attenzione si \xE8 verificato un problema durante la generazione dell\'allegato. ');
                    }
                    else if (response && response.url) {

                        var url = response.url;
                        var name = 'RicevutaID' + vm.record.Id + '.pdf';

                        window.open(url, name);

                        ////recupero allegato appena creato
                        //var a = document.createElement("a");
                        //a.setAttribute('style', 'display:none');
                        //a.setAttribute('target', '_blank');
                        //document.body.appendChild(a);

                        //a.href = response.url;
                        //if ($rootScope.detectIE()) {
                        //    a.target = 'hiddenIframe';
                        //}
                        //else
                        //    a.download = 'RicevutaID' + vm.record.Id + '.pdf';
                        //a.click();
                        //document.body.removeChild(a);

                        return response.url;
                    } else
                        return true;
                });
            }
        };

        // #endregion

        vm.restore = function (item) {
            bDialog.confirmationDialog('REINIZIALIZZAZIONE CAMPI RICEVUTA-PROTCOLLO', 'Si stanno per reinizializzare i campi ricevuta e protocollo. Proseguire?', 'OK').then(
                function () { //YES
                    return datacontext.partecipazione_restore(item.Id).then(function (data) {
                        if (data == 0 || data == null || data == '' || typeof data == 'undefined') {
                            return bDialog.errorDialog('Error on Restore');
                        }

                        item.ProgressivoRicvevuta = 0;
                        item.CodiceRicevuta = '';
                        item.DtRicvevuta = '';
                        item.NumProtSent = '';
                        item.OpProtSent = '';
                        item.DtProtSent = '';

                        var index = vm.records.indexOf(item);
                        if (index !== -1) {
                            vm.records[index] = item;
                        }

                        return logSuccess('Success on Restore');
                    });
                },
                function () { //NO

                }
            );
        };


        //Elenchi Parametri
        function getTMisure() {
            return datacontext.tMisura_getAll().then(function (data) {
                var tmpArray = [];
                data.forEach(function (item) {
                    if (item.GroupCode != 'Mis. 1' && item.GroupCode != 'Mis. 3' && item.GroupCode != 'Mis. 7')
                        tmpArray.push(item);
                })
                return vm.cmblist.tMisure = tmpArray;
            });
        }

        function getProgetti() {
            return datacontext.cndProgetto_getAll(0, 0, '', '', '', $routeParams.TRuoloCode, '', 4, '', '').then(function (data) {
                if (data.constructor === Array) {
                    var dt = new Date();
                    data.forEach(function (prog) {
                        var dtStart = new Date(prog.DtStart);
                        var dtEnd = new Date(prog.DtEnd);
                        if (dt >= dtStart && dt <= dtEnd) {
                            vm.fIFinestra = prog.iFinestra;                            
                        }                        
                    });
                }
                //console.info('progetti', data);
                return vm.cmblist.progetti = data;
            });
        }


        vm.countdownFinished = function () {
            // You can add additional logic here
        };

        function getTRuoli() {
            return datacontext.tRuolo_getAll().then(function (data) {
                var tmpArray = [];
                data.forEach(function (item) {
                    tmpArray.push(item);
                })
                return vm.cmblist.tRuoli = tmpArray;
            });
        }

        function getAPL(tRuoloCode) {
            return datacontext.azienda_getAllList('', '', 0, tRuoloCode, '', '', 0, 0, 0, '', '', '', 0).then(function (data) {
                return vm.cmblist.APL = data;
            });
        }

        function getSettProfess() {
            return datacontext.settProfess_getAllList().then(function (data) {
                return vm.cmblist.settProfess = data;
            });
        }

        function getTFormaGiuridica() {
            if (vm.cmblist.tFormaGiuridica.length > 0) return;

            datacontext.arrFormaGiuridica().then(function (data) {
                vm.cmblist.tFormaGiuridica = data;
            });
        }

        function getCorsiUnassign(aplId) {
            return datacontext.pCorso_getAll(0, 0, '', vm.fTRuoloCode, 0, aplId, 4, '').then(function (data) {
                return vm.list.corsi_unassigned = data;
            });
        }

        vm.getCorsiAssigned = function (partecipazioneId, aplId, bFirst) {
            if (typeof partecipazioneId == 'undefined') return;
            if (vm.loading_crs === true) return;

            if (bFirst) vm.page_crs = 1;

            if (vm.page_crs === 1) {
                vm.list.corsi = [];
                vm.countCorsi = 0;
            }

            var iStato = 2;
            if (vm.record.Sent) {
                iStato = 3;
            }

            if (vm.countCorsi == 0) vm.countCorsiAssigned(partecipazioneId, aplId);
            else if (vm.countCorsi <= vm.list.corsi.length) return;

            vm.loading_crs = true;
            return datacontext.pCorso_getAll(vm.pageSize, vm.page_crs, '', vm.fTRuoloCode, partecipazioneId, aplId, iStato, '').then(function (data) {
                if (data.constructor === Array) {
                    vm.page_crs++;
                    data.forEach(function (item) {
                        vm.list.corsi.push(item);
                    });
                }
                vm.loading_crs = false;
            });
        };

        vm.countCorsiAssigned = function (partecipazioneId, aplId) {
            vm.countCorsi = 0;
            var iStato = 2;
            if (vm.record.Sent) {
                iStato = 3;
            }
            return datacontext.pCorso_countAll('', vm.fTRuoloCode, partecipazioneId, aplId, iStato).then(function (data) {
                return vm.countCorsi = data;
            });
        }

        function getPaesi() {
            if (vm.cmblist.paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.paesi = data;
            });
        }

        function getProvince() {
            if (vm.cmblist.province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.province = data;
            });
        }

        function getProvinceSic() {
            if (vm.cmblist.provinceSic.length > 0) return;

            datacontext.arrProvinceByReg(19).then(function (data) {
                vm.cmblist.provinceSic = data;
            });
        }

        function getTIndirizzi() {
            if (vm.cmblist.tIndirizzi.length > 0) return;

            datacontext.arrTIndirizzo().then(function (data) {
                vm.cmblist.tIndirizzi = data;
            });
        }

        function getTProfiliDocenti() {
            if (vm.cmblist.tProfiloDocenti.length > 0) return;

            datacontext.tProfiloDocente_getAll().then(function (data) {
                vm.cmblist.tProfiloDocenti = data;
            });
        }

        function getTFigProfessionali() {
            var code = '';
            switch (vm.fTRuoloCode) {
                case '2B':
                    code = 'IeFP3';
                    break;
                case '4A':
                    code = 'IeFP4';
                    break;
            }
            return datacontext.tFigProfessionale_getAllList(code).then(function (data) {
                return vm.cmblist.tFigProfessionali = data;
            });
        }

        function getTPercorsi() {
            return datacontext.tPercorso_getAllList().then(function (data) {
                return vm.cmblist.tPercorsi = data;
            });
        }

        function getTAziende() {
            return datacontext.cndTAzienda_getAllList().then(function (data) {
                return vm.cmblist.tAziende = data;
            });
        }

        function getPartners() {
            vm.list.partners = [];
            return datacontext.azienda_getAll(0, 0, '', '', 0, 'AZD_PRTN-FAM1', '', '', 0, vm.record.APLId, -1, '', '', '', 0, '').then(function (data) {
                return vm.list.partners = data;
            });
        }

        vm.changeTAzienda = function (id) {
            if (id == 1) {
                if (vm.list.partAziende.length > 1) {
                    var msg = 'Attenzione, la selezione della tipologia "SOGGETTO PROPONENTE SINGOLO" comporter\xE0 al salvataggio l\'automatica cancellazione delle aziende mandanti e delle relative sedi operative. Procedere? ';
                    bDialog.confirmationDialog('SELEZIONE TIPOLOGIA AZIENDA', msg).then(
                        function () { //YES
                            vm.record.FAM1_ATS_Costituita = false;
                            vm.record.FAM1_TAziendaId = id;
                        },
                        function () { //NO
                            vm.fFAM1_TAziendaId = vm.record.FAM1_TAziendaId;
                        }
                    );
                }
                else {
                    vm.record.FAM1_ATS_Costituita = false;
                    vm.record.FAM1_TAziendaId = id;
                }
            } else {
                vm.record.FAM1_TAziendaId = id;
            }
        };

        function addOrUpdateItem(item) {
            var tMisuraCode = (item.TRuoloCode).substring(item.TRuoloCode.length - 4);
            var msg = 'Attenzione, stai per sincronizzare i campi dell\'istanza con i dati in rubrica dell\'azienda. Procedere? ';
            bDialog.confirmationDialog('SINCRONIZZA CON AZIENDA DA RUBRICA', msg).then(
                function () { //YES
                    return datacontext.partecipazione_addOrUpdate(item).then(function (data) {
                        if (data < 0) return bDialog.errorDialog('Attenzione errore');
                        getRecord(vm.record.Id, vm.idex);
                        return logSuccess('Successo');
                    });
                },
                function () { //NO
                }
            );

        }

        function showMessage(text) {
            return bDialog.informationDialog(text);
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPartecipazione/modal/cndPartecipAdd.html?version=127',
                controller: 'cndPartecipAdd',
                backdrop: 'static',
                resolve: {
                    apl: function () {
                        return vm.cmblist.APL;
                    },
                    tRuoloCode: function () {
                        return vm.fTRuoloCode;
                    },
                    tMisuraCode: function () {
                        return (vm.fTRuoloCode).substring(vm.fTRuoloCode.length - 4);
                    },
                    isSuper: function () {
                        return vm.isSUPER;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                console.info('returnItem', returnItem);
                if (returnItem < 0) {
                    if (returnItem == -2) {
                        return bDialog.errorDialog('Attenzione: prima di procedere bisogna inserire il decreto di accreditamento negli allegati della scheda aziendale.');
                    }
                    if (returnItem == -3) {
                        return bDialog.errorDialog('Attenzione: non \xE8 permesso inserire due istanze per attivit\xE0 di tipo "B" oppure i termini di presentazione sono scaduti. In caso di necessit\xE0 rivolgersi al supporto tecnico. ');
                    }
                    if (returnItem == -4) {
                        return bDialog.errorDialog('Attenzione: non \xE8 permesso inserire due istanze. In caso di necessit\xE0 rivolgersi al supporto tecnico. ');
                    }
                    if (returnItem == -5) {
                        return bDialog.errorDialog('Attenzione: i termini di presentazione sono scaduti. ');
                    }
                    return bDialog.errorDialog('Attenzione: si \xE8 verificato un errore.');
                }

                logSuccess('record creato con successo! ');
                addRecord(returnItem);
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        }

        function editDtlModal(item, index) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPartecipazione/modal/cndPartecipDtlEdit.html?version=127',
                controller: 'cndPartecipDtlEdit',
                backdrop: 'static',
                resolve: {
                    partecipazione: function () {
                        return item;
                    },
                    tAziende: function () {
                        return vm.cmblist.tAziende;
                    },
                    isSuper: function () {
                        return vm.isSUPER;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == 417) return bDialog.errorDialog('Termini per la presentazione scaduti.');
                getRecord(item.Id, index);

            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        }

        // #region PANNELLO ATTACH
        function getTSource(code) {
            if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
            });
        }
        function getTAttach(code) {
            if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0, 0).then(function (data) {
                //console.info('getTAttach()', data);
                return vm.tAttach = data;
            });
        }

        function setfAttach() {
            if (vm.checkfAttach == false) {
                vm.fAttach.TAttachId = '';
            }
        }

        function getListAttach(id) {
            if (!id) return;

            if (vm.fAttach.TAttachId == '' || vm.fAttach.TAttachId == null || typeof vm.fAttach.TAttachId == 'undefined') {
                vm.fAttach.TAttachId = 0;
            }

            return datacontext.attach_getAll(0, 0, id, 0, vm.tSourceCode_def, 0, 0, '', vm.fAttach.TAttachId, 0, '').then(function (data) {
                vm.list.b_attach = true;
                if (!$.isNumeric(data)) vm.list.attach = data;
                //console.info('attach_getAll', data);
                return datacontext.tAttachVisibility_getAuth(vm.tSourceCode_def).then(function (data_TAV) {
                    var tAttVis = data_TAV;

                    vm.list.attach.forEach(function (item_A) {
                        var myTAV = _.find(tAttVis, { 'TAttachId': item_A.TAttachId });

                        if (typeof myTAV == 'undefined') {
                            myTAV = {};
                            myTAV.bRead = true;
                            myTAV.bInsert = true;
                            myTAV.bUpdate = true;
                            myTAV.bDelete = true;
                            myTAV.iTags = 0;
                        }

                        item_A.bRead = myTAV.bRead;
                        item_A.bInsert = myTAV.bInsert;
                        item_A.bUpdate = myTAV.bUpdate;
                        item_A.bDelete = myTAV.bDelete;
                        item_A.iTags = myTAV.iTags;

                        if (!item_A.bRead) {
                            var index = vm.list.attach.indexOf(item_A);
                            vm.list.attach.splice(index, 1);
                        }

                    });

                    return vm.list.attach = data;
                });
            });
        }

        vm.addAttach = function (item, _tAttachId) {
            if (!vm.isSpecial && vm.record.iConvalidaSedi == 1)
                return bDialog.informationDialog('Attenzione: bisogna convalidare le sedi prima di poter aggiungere gli allegati necessari. ');

            console.info('_tAttachId', _tAttachId);
            var recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
            var recSource = { Id: vm.record.Id, Name: vm.record.APL };

            var modalInstance = modal.open({
                templateUrl: '/app/ATT/attach/modal/attachAdd.html?version=127',
                controller: 'attachAdd',
                backdrop: 'static',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        var tatt = typeof _tAttachId == 'undefined' ? (typeof item == 'undefined' ? null : vm.tAttach) : vm.tAttach;
                        return tatt;
                    },
                    tAttachId: function () {
                        var tattid = typeof _tAttachId == 'undefined' ? (typeof item == 'undefined' ? null : item.TAttachId) : _tAttachId;
                        return tattid;
                    },
                    attach: function () {
                        return item;
                    },
                    anomalia: function () {
                        return false;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "417") return bDialog.errorDialog('Attenzione: entit\xE0 bloccata. ');
                if (returnItem == "401") return bDialog.errorDialog('Attenzione: azione non autorizzata. ');
                if (returnItem == "406") return bDialog.errorDialog('Attenzione: allegato non permesso. ');
                if (returnItem == "409") return bDialog.errorDialog('Attenzione: allegato alterato rispetto all\'originale. ');
                if ($.isNumeric(returnItem)) return bDialog.errorDialog('Attenzione: errore generico. ');
                //Documenti con hashcode diverso da originale ma non bloccante
                if (returnItem.alert != null) { bDialog.informationDialog(returnItem.alert); }

                logSuccess('Dato salvato con successo! ');
                getListAttach(vm.record.Id);

            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deleteAttach = function (item) {
            var msg = ' Allegato ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return bDialog.errorDialog('Attenzione: entit\xE0 bloccata. ');
                    if (data == "401") return bDialog.errorDialog('Attenzione: azione non autorizzata. ');
                    if (data == "404") return bDialog.errorDialog('Attenzione: entit\xE0 inesistente. ');
                    if (data == "417") return bDialog.errorDialog('Attenzione: azione non permessa, perch\xE8 entit\xE0 bloccata in cascata da altri elementi. ');

                    var index = vm.list.attach.indexOf(item);
                    vm.list.attach.splice(index, 1);
                });
            });
        };



        // #endregion ATTACH

        // #region Corso

        vm.assignCorso = function (item) {
            return getCorsiUnassign(item.APLId).then(function () {
                var modalInstance = modal.open({
                    templateUrl: '/app/CND/CNDPartecipazione/modal/cndPCorsoAssign.html?version=127',
                    controller: 'cndPCorsoAssign',
                    backdrop: 'static',
                    resolve: {
                        partecipazioneId: function () {
                            return item.Id;
                        },
                        corsi: function () {
                            return vm.list.corsi_unassigned;
                        },
                        isSuper: function () {
                            return vm.isSUPER;
                        }
                    }
                });

                modalInstance.result.then(function (returnItem) {
                    if (returnItem == "404") return bDialog.errorDialog('Attenzione: raggiunto il numero massimo consentito di percorsi. ');
                    if (!returnItem || $.isNumeric(returnItem)) return bDialog.errorDialog('errore di creazione! ');

                    logSuccess('record creato con successo! ');
                    vm.getCorsiAssigned(item.Id, item.APLId);
                }, function () {
                    //log('Modal dismissed at: ' + new Date());
                });
            });
        };

        vm.assignAll = function (item) {
            bDialog.confirmationDialog('ASSEGNAZIONE PERCORSI CONVALIDATI', 'Si stanno per aggiungere tutti i percorsi convalidati precedentemente. Proseguire?', 'OK').then(
                function () { //YES
                    $('#loadingModal').modal('show');
                    return getCorsiUnassign(item.APLId).then(function () {
                        fn_assignAll(item.Id);
                    }).then(function () {
                        $('#loadingModal').modal('hide');
                        vm.getCorsiAssigned(item.Id, item.APLId, true);
                    });
                },
                function () { //NO

                }
            );

        };

        function fn_assignAll(partecipazioneId) {
            if (vm.list.corsi_unassigned.length == 0) return;

            vm.list.corsi_unassigned.forEach(function (item) {
                if (item.PartecipazioneId == 0)
                    item.PartecipazioneId = partecipazioneId;

                datacontext.pCorso_assign(item);
            });

            return true;
        }

        vm.deleteCorso = function (item) {
            var msg = ' Percorso ' + item.NomeCorso;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.pCorso_unassign(item).then(function (data) {
                    if (data == "400") return bDialog.errorDialog('Attenzione: percorso non cancellabile. ');

                    var index = vm.list.corsi.indexOf(item);
                    if (index !== -1) {
                        vm.list.corsi.splice(index, 1);
                    }
                });
            });
        };

        // #endregion

        // #region Tir Categoria

        vm.addTirCateg = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPartecipazione/modal/cndTirCategAdd.html?version=127',
                controller: 'cndTirCategAdd',
                backdrop: 'static',
                resolve: {
                    settore: function () {
                        return item;
                    },
                    partecipazioneId: function () {
                        return vm.record.Id;
                    },
                    apl: function () {
                        return vm.cmblist.APL;
                    },
                    settProfess: function () {
                        return vm.cmblist.settProfess;
                    },
                    numMaxTir: function () {
                        return vm.record.M5_NumTir;
                    },
                    isSuper: function () {
                        return vm.isSUPER;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem || $.isNumeric(returnItem)) {
                    if (returnItem == "406")
                        return bDialog.errorDialog('Attenzione: il numero totale di tirocini \xE8 "200" (duecento). Verificare il numero inserito. ');

                    return bDialog.errorDialog('errore di creazione! ');
                }

                vm.getTirCateg(vm.record.Id, vm.record.APLId);
                logSuccess('record creato con successo! ');
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deleteTirCateg = function (item) {
            var msg = ' Settore Professionale ' + item.ProfiloProfess;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.pTirCateg_unassign(item).then(function (data) {
                    if (data == "400") return bDialog.errorDialog('Attenzione: percorso non cancellabile. ');

                    var index = vm.list.tirCateg.indexOf(item);
                    vm.list.tirCateg.splice(index, 1);
                });
            });
        };

        vm.getTirCateg = function (partecipazioneId, aplId) {
            vm.list.tirCateg = [];
            return datacontext.pTirCateg_getAll(0, 0, '', partecipazioneId, aplId, 0, 4, '').then(function (data) {
                vm.getSummary(data, partecipazioneId);
                return vm.list.tirCateg = data;
            });
        };

        vm.getSummary = function (array, partecipazioneId) {
            vm.totTirocini = 0;
            return array.forEach(function (item) {
                if (item.PartecipazioneId == partecipazioneId) {
                    vm.totTirocini += item.NumTirocini;
                }

                return true;
            });
        };

        // #endregion

        // #region Partecipazione Docente

        vm.addPartDocente = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPartecipazione/modal/cndPDocenteAdd.html?version=127',
                controller: 'cndPDocenteAdd',
                backdrop: 'static',
                resolve: {
                    partDocente: function () {
                        return item;
                    },
                    province: function () {
                        return vm.cmblist.province;
                    },
                    paesi: function () {
                        return vm.cmblist.paesi;
                    },
                    tProfiloDocenti: function () {
                        return vm.cmblist.tProfiloDocenti;
                    },
                    partecipazioneId: function () {
                        return vm.record.Id;
                    },
                    isSuper: function () {
                        return vm.isSUPER;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem || $.isNumeric(returnItem)) {
                    if (returnItem == "300")
                        return bDialog.errorDialog('Attenzione: entit\xE0 convalidata. ');
                    else if (returnItem == "406")
                        return bDialog.errorDialog('Attenzione: il docente \xE8 gi\xE0 stato inserito. ');

                    return bDialog.errorDialog('errore di creazione! ');
                }

                vm.getPartDocenti(vm.record.Id);
                logSuccess('record creato con successo! ');
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deletePartDocente = function (item) {
            var msg = ' Docente ' + item.Cognome + ' ' + item.Nome + ' ' + item.CodiceFiscale;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.pDocente_delete(item.Id).then(function (data) {
                    if (data == "400") return bDialog.errorDialog('Attenzione: docente non cancellabile. ');

                    var index = vm.list.partDocenti.indexOf(item);
                    if (index !== -1) {
                        vm.list.partDocenti.splice(index, 1);
                    }
                    return logSuccess('record eliminato con successo! ');
                });
            });
        };

        vm.getPartDocenti = function (partecipazioneId) {
            vm.list.partDocenti = [];
            return datacontext.pDocente_getAll(0, 0, '', partecipazioneId, '', '', 0, '').then(function (data) {
                //console.info('vm.getPartDocenti()', data);
                return vm.list.partDocenti = data;
            });
        };

        // #endregion

        // #region Partecipazione Sede

        vm.importPartSede = function (item) {

            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPartecipazione/modal/cndPSedeImport.html?version=127',
                controller: 'cndPSedeImport',
                backdrop: 'static',
                resolve: {
                    partecipazioneId: function () {
                        return vm.record.Id;
                    },
                    aziende: function () {
                        return [{ Id: vm.record.APLId, Name: vm.record.RagioneSociale }];
                    },
                    aziendaId: function () {
                        return vm.record.APLId;
                    },
                    tRuoloCode: function () {
                        return vm.record.TRuoloCode;
                    },
                    isSuper: function () {
                        return vm.isSUPER;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                console.info('vm.importPartSede', returnItem);
                if (!returnItem || $.isNumeric(returnItem)) {
                    if (returnItem == "300")
                        return bDialog.errorDialog('Attenzione: entit\xE0 convalidata. ');

                    return bDialog.errorDialog('errore di creazione! ');
                }

                vm.getPartSedi(vm.record.Id);
                logSuccess('record creato con successo! ');
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.addPartSede = function (item) {

            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPartecipazione/modal/cndPSedeAdd.html?version=127',
                controller: 'cndPSedeAdd',
                backdrop: 'static',
                resolve: {
                    partSede: function () {
                        return item;
                    },
                    province: function () {
                        return vm.cmblist.province;
                    },
                    provinciaId: function () {
                        return vm.filterProvince;
                    },
                    tIndirizzi: function () {
                        return vm.cmblist.tIndirizzi;
                    },
                    partecipazioneId: function () {
                        return vm.record.Id;
                    },
                    aziende: function () {
                        return vm.list.partAziende;
                    },
                    aziendaId: function () {
                        return vm.list.partAziende != null && vm.list.partAziende.length == 1 ? vm.list.partAziende[0].Id : null;
                    },
                    tRuoloCode: function () {
                        return vm.record.TRuoloCode;
                    },
                    isSuper: function () {
                        return vm.isSUPER;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                //console.info('vm.addPartSede', returnItem);
                if (!returnItem || $.isNumeric(returnItem)) {
                    if (returnItem == "300")
                        return bDialog.errorDialog('Attenzione: entit\xE0 convalidata. ');

                    return bDialog.errorDialog('errore di creazione! ');
                }

                vm.getPartSedi(vm.record.Id);
                logSuccess('record creato con successo! ');
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deletePartSede = function (item) {
            var msg = ' Sede: ' + item.Provincia + ' - ' + item.Comune + ', ' + item.TIndirizzo + ' ' + item.Indirizzo + ' n. ' + item.Civico;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.pSede_delete(item.Id).then(function (data) {
                    if (data == "400") return bDialog.errorDialog('Attenzione: sede non cancellabile. ');

                    var index = vm.list.partSedi.indexOf(item);
                    if (index !== -1) {
                        vm.list.partSedi.splice(index, 1);
                    }
                    return logSuccess('record eliminato con successo! ');
                });
            });
        };

        vm.getPartSedi = function (partecipazioneId) {
            vm.list.partSedi = [];
            return datacontext.pSede_getAll(0, 0, '', partecipazioneId, 0, 0, '', 0, -1, 0, 0, 0, 0, '').then(function (data) {
                //console.info('vm.getPartSedi()', data);
                if (vm.record.TRuoloCode == 'AZD_PROM-LAV1' || vm.record.TRuoloCode == 'AZD_PROM-FAM1') {
                    setNotaS1(data);
                    setNotaS2(data);
                }
                if (vm.filterProvince != null) {
                    data = _.filter(data, function (o) {
                        return o.ProvinciaId == vm.filterProvince;
                    });
                }

                return vm.list.partSedi = data;
            });
        };

        function setNotaS1(data) {
            if (data != null && data.length > 0) {
                data.forEach(function (e) {
                    var title = 'Servizi:';
                    if (e.Serv1_Ori)
                        title += '\n-Orientamento specialistico;';
                    if (e.Serv1_Coll)
                        title += '\n-Accompagnamento al lavoro;';
                    if (e.Serv1_Form)
                        title += '\n-Avviamento alla formazione;';
                    if (e.Serv1_Tir && vm.record.TRuoloCode == 'AZD_PROM-FAM1')
                        title += '\n-Promozione di tirocini extracurriculari;';
                    if (e.Serv1_Info)
                        title += '\n-Informazione su incentivi all\'occupazione;';
                    if (e.Serv1_Aim)
                        title += '\n-Supporto all\'autoimpiego;';
                    if (e.Serv1_Match)
                        title += '\n-Attivit\xE0 incontro domanda/offerta di lavoro (Matching).';
                    if (vm.record.TRuoloCode == 'AZD_PROM-LAV1' && !e.Serv1_Ori && !e.Serv1_Coll && !e.Serv1_Form && !e.Serv1_Info && !e.Serv1_Aim && !e.Serv1_Match)
                        title = 'Nessun servizio';
                    if (vm.record.TRuoloCode == 'AZD_PROM-FAM1' && !e.Serv1_Ori && !e.Serv1_Coll && !e.Serv1_Form && !e.Serv1_Tir && !e.Serv1_Info && !e.Serv1_Aim && !e.Serv1_Match)
                        title = 'Nessun servizio';
                    e.NotaS1 = title;
                });
                return data;
            }
        }

        function setNotaS2(data) {
            if (data != null && data.length > 0) {
                data.forEach(function (e) {
                    var title = 'Servizi:';
                    if (e.Serv2_AccrA || e.Serv2_AutA)
                        title += '\n-Tipologia A;';
                    if (e.Serv2_AccrB || e.Serv2_AutB)
                        title += '\n-Tipologia B;';
                    if (e.Serv2_AccrC)
                        title += '\n-Tipologia C;';
                    if (!e.Serv2_AccrA && !e.Serv2_AccrB && !e.Serv2_AccrC && !e.Serv2_AutA && !e.Serv2_AutB)
                        title = 'Nessun servizio';
                    e.NotaS2 = title;
                });
                return data;
            }
        }

        // #endregion


        vm.getSediAccr = function () {
            vm.list.sediAccr = [];
            return datacontext.fse_AccreditamentoSede_Get('', vm.record.PIVA, vm.record.CodiceFiscale, 0).then(function (data) {
                console.info('vm.getSediAccr()', data);
                return vm.list.sediAccr = data;
            });
        }

        // #region Partecipazione Aziende

        vm.addPartAzienda = function (item) {
            //console.info('vm.addPartAzienda(%s)', item);
            if (typeof item == undefined) {
                item = null;
            }

            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPartecipazione/modal/cndPAziendaAdd.html?version=127',
                controller: 'cndPAziendaAdd',
                backdrop: 'static',
                resolve: {
                    partAzienda: function () {
                        return item;
                    },
                    paesi: function () {
                        return vm.cmblist.paesi;
                    },
                    province: function () {
                        return vm.cmblist.province;
                    },
                    tIndirizzi: function () {
                        return vm.cmblist.tIndirizzi;
                    },
                    tFormaGiuridica: function () {
                        return vm.cmblist.tFormaGiuridica;
                    },
                    partecipazioneId: function () {
                        return vm.record.Id;
                    },
                    capofilaId: function () {
                        return vm.CapofilaId;
                    },
                    isCapofila: function () {
                        return item != null && item.Id == vm.CapofilaId;
                    },
                    tRuoloCode: function () {
                        return vm.record.TRuoloCode;
                    },
                    isSuper: function () {
                        return vm.isSUPER;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem || $.isNumeric(returnItem)) {
                    if (returnItem == "304")
                        return bDialog.errorDialog('Attenzione: entit\xE0 bloccata. ');
                    if (returnItem == "406")
                        return bDialog.errorDialog('Attenzione: tentativo di duplicazione. ');

                    return bDialog.errorDialog('Attenzione: errore di creazione e/o tentativo di duplicazione. ');
                }

                vm.getPartAziende();
                logSuccess('record creato con successo! ');
                //if (typeof (item) == 'undefined' || item == undefined) {
                //    vm.record.PAziende.push(returnItem);
                //    updateItem();
                //    return logSuccess('Record creato con successo! ');
                //}
                //else {
                //    var index = vm.record.Visibility.indexOf(item);
                //    vm.record.PAziende[index] = returnItem;
                //    updateItem();
                //    return logSuccess('Record modificato con successo! ');
                //}
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.selectPartAzienda = function (item) {
            //console.info('vm.addPartAzienda(%s)', item);
            if (typeof item == undefined) {
                item = null;
            }

            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPartecipazione/modal/cndPAziendaSelect.html?version=127',
                controller: 'cndPAziendaSelect',
                backdrop: 'static',
                resolve: {
                    partecipazioneId: function () {
                        return vm.record.Id;
                    },
                    aziende: function () {
                        return vm.list.partners;
                    },
                    isSuper: function () {
                        return vm.isSUPER;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem || $.isNumeric(returnItem)) {
                    if (returnItem == "304")
                        return bDialog.errorDialog('Attenzione: entit\xE0 bloccata. ');
                    if (returnItem == "406")
                        return bDialog.errorDialog('Attenzione: tentativo di duplicazione. ');

                    return bDialog.errorDialog('Attenzione: errore di creazione e/o tentativo di duplicazione. ');
                }

                getPartners();
                vm.getPartAziende();
                logSuccess('record creato con successo! ');

            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deletePartAzienda = function (item) {
            var msg = 'Stai per cancellare il partner ' + item.RagioneSociale + ', questa azione comporter\xE0 la cancellazione delle relative sedi e dei budget inseriti. Procedere? ';
            bDialog.confirmationDialog('CONFERMA DI CANCELLAZIONE', msg).then(function () {
                return datacontext.azienda_delete(item.Id).then(function (data) {
                    if (data == "400") return bDialog.errorDialog('Attenzione: sede non cancellabile. ');
                    if (data == "304") return bDialog.errorDialog('Attenzione: entit\xE0 bloccata. ');

                    var index = vm.list.partAziende.indexOf(item);
                    if (index !== -1) {
                        vm.list.partAziende.splice(index, 1);
                    }
                    return logSuccess('record eliminato con successo! ');
                });
            });
        };

        vm.removePartAzienda = function (item) {
            var msg = 'Stai per rimuovere il partner ' + item.RagioneSociale + ', questa azione comporter\xE0 la cancellazione delle relative sedi e dei budget inseriti. Procedere? ';
            bDialog.confirmationDialog('CONFERMA DI CANCELLAZIONE', msg).then(function () {
                item.PartecipazioneId = 0;
                return datacontext.azienda_saveComplete(item).then(function (data) {
                    if (data == "400") return bDialog.errorDialog('Attenzione: sede non cancellabile. ');
                    if (data == "304") return bDialog.errorDialog('Attenzione: entit\xE0 bloccata. ');

                    var index = vm.list.partAziende.indexOf(item);
                    if (index !== -1) {
                        vm.list.partAziende.splice(index, 1);
                    }

                    getPartners();
                    return logSuccess('record eliminato con successo! ');
                });
            });
        };

        vm.getPartAziende = function () {
            vm.list.partAziende = [];
            vm.CapofilaId = 0;
            return datacontext.azienda_getAll(0, 0, '', '', 0, '', '', '', 0, 0, vm.record.Id, '', '', '', 0, '').then(function (data) {
                console.info('vm.getPartAziende', data);
                if (data) {
                    vm.list.partAziende = jQuery.extend([], data);
                }

                var proponente = { Id: vm.record.APLId, RagioneSociale: vm.record.APL, Capofila: true, Name: vm.record.APL + ' (Capofila)' };
                vm.list.partAziende.push(proponente);

                var azdCapofila = _.find(vm.list.partAziende, { 'Capofila': true });
                if (azdCapofila) {
                    vm.CapofilaId = azdCapofila.Id;
                }

                return vm.list.partAziende = _.sortBy(vm.list.partAziende, [-'Capofila', 'RagioneSociale']);;
            });
        };

        // #endregion

        // #region Partecipazione Budget

        vm.addPBudget = function (item) {
            //console.info('vm.addPBudget(%s)', item);
            if (typeof item == undefined) {
                item = null;
            }

            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPartecipazione/modal/cndPBudgetAdd.html?version=127',
                controller: 'cndPBudgetAdd',
                backdrop: 'static',
                resolve: {
                    pBudget: function () {
                        return item;
                    },
                    partecipazioneId: function () {
                        return vm.record.Id;
                    },
                    aziende: function () {
                        return vm.list.partAziende;
                    },
                    aziendaId: function () {
                        return null;
                    },
                    isSuper: function () {
                        return vm.isSUPER;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem || $.isNumeric(returnItem)) {
                    if (returnItem == "304")
                        return bDialog.errorDialog('Attenzione: entit\xE0 bloccata. ');
                    if (returnItem == "406")
                        return bDialog.errorDialog('Attenzione: tentativo di duplicazione. ');

                    return bDialog.errorDialog('errore di creazione! ');
                }

                vm.getPBudget();
                logSuccess('record creato con successo! ');
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deletePBudget = function (item) {
            var msg = ' Budget per ' + item.Attivita + ' del soggetto ' + item.APL;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.pBudget_delete(item.Id).then(function (data) {
                    if (data == "400") return bDialog.errorDialog('Attenzione: budget non cancellabile. ');
                    if (data == "304") return bDialog.errorDialog('Attenzione: entit\xE0 bloccata. ');

                    var index = vm.list.pBudget.indexOf(item);
                    if (index !== -1) {
                        vm.list.pBudget.splice(index, 1);
                    }
                    return logSuccess('record eliminato con successo! ');
                });
            });
        };

        vm.getPBudget = function () {
            vm.list.pBudget = [];
            vm.PB_ImportoTotale = 0;
            return datacontext.pBudget_getAll(0, 0, '', vm.record.Id, 0, 0, '').then(function (data) {
                if (data) {
                    data = _.sortBy(data, ['APL', 'Attivita']);
                    data.forEach(function (pb) {
                        if (pb != null) {
                            vm.PB_ImportoTotale += pb.ImpTot;
                        }
                    });
                }
                //console.info('vm.getPBudget()', data);
                return vm.list.pBudget = data;
            });
        };

        // #endregion

        // #region Partecipazione Modulo

        vm.addPartModulo = function (item) {
            if (typeof item == undefined) {
                item = null;
            }

            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPartecipazione/modal/cndPartModuloAdd.html?version=127',
                controller: 'cndPartModuloAdd',
                backdrop: 'static',
                resolve: {
                    partModulo: function () {
                        return item;
                    },
                    partecipazioneId: function () {
                        return vm.record.Id;
                    },
                    province: function () {
                        return vm.cmblist.province;
                    },
                    provinciaId: function () {
                        return null;
                    },
                    tIndirizzi: function () {
                        return vm.cmblist.tIndirizzi;
                    },
                    tRuoloCode: function () {
                        return vm.record.TRuoloCode;
                    },
                    showIES: function () {
                        return !vm.PartModuli_bIES;
                    },
                    onlyRead: function () {
                        return vm.record.Annulled || vm.isFAM || (vm.record.Completed && !vm.record.IssueAPL) || vm.record.iConvalida > 0;
                    },
                    isSuper: function () {
                        return vm.isSUPER;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem || $.isNumeric(returnItem)) {
                    if (returnItem == "304")
                        return bDialog.errorDialog('Attenzione: entit\xE0 bloccata. ');
                    if (returnItem == "406")
                        return bDialog.errorDialog('Attenzione: tentativo di duplicazione. ');

                    return bDialog.errorDialog('errore di creazione! ');
                }

                vm.getPartModulo();
                logSuccess('record creato con successo! ');
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deletePartModulo = function (item) {
            var msg = ' Modulo Formativo ' + item.NomeModulo;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.partecipazioneModulo_delete(item.Id).then(function (data) {
                    if (data == "400") return bDialog.errorDialog('Attenzione: modulo non cancellabile. ');
                    if (data == "304") return bDialog.errorDialog('Attenzione: entit\xE0 bloccata. ');

                    //var index = vm.list.partModuli.indexOf(item);
                    //if (index !== -1) {
                    //    vm.list.partModuli.splice(index, 1);
                    //}
                    vm.getPartModulo();
                    return logSuccess('record eliminato con successo! ');
                });
            });
        };

        vm.PartModuli_TotOre = 0;
        vm.PartModuli_bIES = false;
        vm.getPartModulo = function () {
            vm.list.partModuli = [];
            vm.PartModuli_TotOre = 0;
            vm.PartModuli_bIES = false;
            return datacontext.partecipazioneModulo_getAll(0, 0, '', vm.record.Id, vm.record.TRuoloCode, 0, '', '', 0, 0, 0, 'Modulo').then(function (data) {
                if (data.constructor === Array) {
                    console.log(data);
                    data.forEach(function (item) {
                        vm.PartModuli_TotOre += item.Ore;
                        if (item.CodiceFigura == 'IES') {
                            vm.PartModuli_bIES = true;
                        }
                    });
                }
            
                return vm.list.partModuli = data;
            });
        };

        // #endregion

        // #region Partecipazione Catalogo Corso - Misura 2-B

        vm.addPCatalogoCorso = function (item) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDPartecipazione/modal/cndPCatalogoCorsoAdd.html?version=127',
                controller: 'cndPCatalogoCorsoAdd',
                backdrop: 'static',
                resolve: {
                    pCatalogoCorso: function () {
                        return item;
                    },
                    partecipazioneId: function () {
                        return vm.record.Id;
                    },
                    aplId: function () {
                        return vm.record.APLId;
                    },
                    tRuoloCode: function () {
                        return vm.fTRuoloCode;
                    },
                    province: function () {
                        return vm.cmblist.provinceSic;
                    },
                    tIndirizzi: function () {
                        return vm.cmblist.tIndirizzi;
                    },
                    tFigProfessionali: function () {
                        return vm.cmblist.tFigProfessionali;
                    },
                    tPercorsi: function () {
                        return vm.cmblist.tPercorsi;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem || $.isNumeric(returnItem)) {
                    if (returnItem == "300")
                        return bDialog.errorDialog('Attenzione: entit\xE0 convalidata. ');
                    else if (returnItem == "401")
                        return bDialog.errorDialog('Attenzione: catalogo esistente. ');

                    return bDialog.errorDialog('errore di creazione! ');
                }

                vm.getPCatalogoCorsi(vm.record.Id);
                logSuccess('record creato con successo! ');
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };

        vm.deletePCatalogoCorso = function (item) {
            var msg = ' Percorso Formativo ' + item.TFigProfessionale;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.pCatalogoCorso_delete(item.Id).then(function (data) {
                    if (data == "400") return bDialog.errorDialog('Attenzione: sede non cancellabile. ');

                    var index = vm.list.pCatalogoCorsi.indexOf(item);
                    if (index !== -1) {
                        vm.list.pCatalogoCorsi.splice(index, 1);
                    }
                    return logSuccess('record eliminato con successo! ');
                });
            });
        };

        vm.getPCatalogoCorsi = function (partecipazioneId) {
            vm.list.pCatalogoCorsi = [];
            return datacontext.pCatalogoCorso_getAll(0, 0, '', vm.fTRuoloCode, partecipazioneId, 0, 0, '').then(function (data) {
                //console.info('vm.getPCatalogoCorsi()', data);
                return vm.list.pCatalogoCorsi = data;
            });
        };

        // #endregion


        //------------------------------ANOMALIE------------------------------------------------------------
        function setIssueCPISolved() {
            if (vm.record.ass_Note == null)
                vm.record.ass_Note = '';

            var today = moment().format('DD/MM/YYYY');

            if (vm.record.IssueCPI != '')
                vm.record.ass_Note += '\nAnomalia CPI risolta: ' + today + ' - ' + vm.record.IssueCPIDescr;

            vm.record.IssueCPI = 0;
            vm.record.IssueCPIDescr = '';
            //vm.record.Sent = true;

            //updateItem();
            modalInviaUMC();
        }

        function setIssueAPLSolved() {
            if (vm.record.ass_Note == null)
                vm.record.ass_Note = '';

            var today = moment().format('DD/MM/YYYY');

            if (vm.record.IssueAPL != '')
                vm.record.ass_Note += '\nAnomalia APL risolta: ' + today + ' - ' + vm.record.IssueAPLDescr;

            vm.record.IssueAPL = 0;
            vm.record.IssueAPLDescr = '';
            //vm.record.Sent = true;

            //updateItem();
            //setSentCPI();
            //modalInviaUMC();
        }

        function setPresaIncarico() {
            bDialog.confirmationDialog('Attenzione', 'L\'istanza verr\xE0 "PRESA INCARICO" dall\'operatore. Proseguire?', 'OK').then(
                function () { //YES
                    vm.record.bPresaIncarico = true;
                    datacontext.partecipazione_changePresaIncarico(vm.record.Id, 'set').then(function (data) {
                        if (data == "404") return bDialog.errorDialog('Errore: operazione non consentita');
                        else {
                            vm.record.bPresaIncarico = true;
                            getRecord(vm.record.Id, vm.index);
                            return logSuccess('Istanza presa in carico.');
                        }
                    });

                },
                function () { //NO
                    //vm.record.bPresaIncarico = false;
                }
            );
        }

        function unsetPresaIncarico() {
            var item = vm.record;
            bDialog.confirmationDialog('Attenzione', 'Sei sicuro di voler rimuovere la "PRESA INCARICO" per l\'istanza? ', 'OK').then(
                function () { //YES
                    return datacontext.partecipazione_changePresaIncarico(item.Id, 'remove').then(function (data) {
                        if (data == "404") return bDialog.errorDialog('Errore: operazione non consentita');
                        else {
                            vm.record.bPresaIncarico = false;
                            getRecord(vm.record.Id, vm.index);
                            return logSuccess('Presa in carico rimossa');
                        }
                    });
                },
                function () { //NO
                    //vm.record.bPresaIncarico = false;
                }
            );
        }

        function setPresaIncaricoCPI() {
            bDialog.confirmationDialog('Attenzione', 'L\'istanza verr\xE0 "PRESA INCARICO CPI" dall\'operatore. Proseguire?', 'OK').then(
                function () { //YES
                    vm.record.bPresaIncaricoCPI = true;
                    datacontext.partecipazione_changePresaIncarico(vm.record.Id, 'set-cpi').then(function (data) {
                        if (data == "404") return bDialog.errorDialog('Errore: operazione non consentita');
                        else {
                            vm.record.bPresaIncaricoCPI = true;
                            getRecord(vm.record.Id, vm.index);
                            return logSuccess('Istanza presa in carico CPI.');
                        }
                    });

                },
                function () { //NO
                    //vm.record.bPresaIncaricoCPI = false;
                }
            );
        }

        function unsetPresaIncaricoCPI() {
            var item = vm.record;
            bDialog.confirmationDialog('Attenzione', 'Sei sicuro di voler rimuovere la "PRESA INCARICO CPI" per l\'istanza? ', 'OK').then(
                function () { //YES
                    return datacontext.partecipazione_changePresaIncarico(item.Id, 'remove-cpi').then(function (data) {
                        if (data == "404") return bDialog.errorDialog('Errore: operazione non consentita');
                        else {
                            vm.record.bPresaIncaricoCPI = false;
                            getRecord(vm.record.Id, vm.index);
                            return logSuccess('Presa in carico rimossa CPI');
                        }
                    });
                },
                function () { //NO
                    //vm.record.bPresaIncarico = false;
                }
            );
        }

        function setIssue(item, iRole) { //Item � l'ATTACH
            if (!iRole || iRole == 0) return;

            switch (iRole) {
                case 1: //Anomalia da CPI all'APL
                    if (!vm.record.bPresaIncaricoCPI) {
                        return bDialog.errorDialog('Per poter aggiungere un\'anomalia \xE8 necessario che la pratica sia presa in carico dal CPI.');
                    }
                    break;
                case 2: //Anomalia da UMC al CPI 
                    if (!vm.record.bPresaIncarico) {
                        return bDialog.errorDialog('Per poter aggiungere un\'anomalia \xE8 necessario che la pratica sia presa in carico dall\'UMC.');
                    }
                    break;
                case 3: //Anomalia da UMC all'APL 
                    if (!vm.record.bPresaIncarico) {
                        return bDialog.errorDialog('Per poter aggiungere un\'anomalia \xE8 necessario che la pratica sia presa in carico dall\'UMC.');
                    }
                    break;
            }

            if (!(vm.isUMC || vm.isSUPER || vm.isFAM)) {
                return bDialog.errorDialog('Azione non autorizzata.');
            }

            var tSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
            var source = { Id: vm.record.Id, Name: 'ID: ' + vm.record.Id + ' - ' + vm.record.CodiceRicevuta + ' del ' + moment(vm.record.DtRicevuta).format('DD/MM/YYYY') };

            var modalInstance = modal.open({
                templateUrl: '/app/STRUMENTI/issueLog/modal/issueLogAdd.html?version=127',
                controller: 'issueLogAdd',
                backdrop: 'static',
                resolve: {
                    tMisuraCode: function () {
                        return vm.fTMisuraCode;
                    },
                    tRuoloCode: function () {
                        return vm.fTRuoloCode;
                    },
                    tSource: function () {
                        return [tSource];
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    source: function () {
                        return [source];
                    },
                    sourceId: function () {
                        return vm.record.Id;
                    },
                    tDestId: function () {
                        switch (iRole) {
                            case 1:
                            case 3:
                                return 2; //il destinatario � l'APL
                            case 2:
                                return 1; //il destinatario � il CPI
                        }
                    },
                    dest: function () {
                        switch (iRole) {
                            case 1:
                            case 3:
                                return vm.record.APL; //il destinatario � l'APL
                            case 2:
                                return vm.record.CPI; //il destinatario � il CPI
                        }
                    },
                    destId: function () {
                        switch (iRole) {
                            case 1:
                            case 3:
                                return vm.record.APLId; //il destinatario � l'APL
                            case 2:
                                return vm.record.CPIId; //il destinatario � il CPI
                        }
                    },
                    bResponse: function () {
                        return false;
                    },
                    iRole: function () {
                        return iRole;
                    },
                    issueLog: function () {
                        return undefined;
                    },
                    bozza: function () {
                        return false;
                    },
                    showDtScad: function () {
                        return vm.showDtScad;
                    },
                    attachId: function () {
                        return item.Id;
                    }

                }
            });

            modalInstance.result.then(function (returnItem) {
                //console.log('returnItem %s', returnItem);
                //returnItem � undefined perch� il js risponde prima di C#
                if (returnItem && returnItem == "409") return bDialog.errorDialog('errore di creazione! ');

                setTimeout(function () { getListAttach(vm.record.Id); }, 200);
                return logSuccess('Dato salvato con successo! ');
            }, function () {
                //
            });

        }

        function unsetIssue(item) {
            var recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
            var recSource = { Id: vm.record.Id, Name: 'ID: ' + vm.record.Id + ' - ' + vm.record.CodiceRicevuta + ' del ' + moment(vm.record.DtRicevuta).format('DD/MM/YYYY') };

            var modalInstance = modal.open({
                templateUrl: '/app/ATT/attach/modal/attachAdd.html?version=127',
                controller: 'attachAdd',
                backdrop: 'static',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return recTSource.Code;
                    },
                    tSourceId: function () {
                        return recTSource.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        return null;
                    },
                    tAttachId: function () {
                        return null;
                    },
                    attach: function () {
                        return item;
                    },
                    anomalia: function () {
                        return true;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "406") return bDialog.errorDialog('Errore: allegato non inseribile! ');
                if (!returnItem) return bDialog.errorDialog('errore di creazione! ');

                getListAttach(vm.record.Id);
                logSuccess('Anomalia allegato risolta');
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        }

        function addIssueLogMultiplo() {
            var modalInstance = modal.open({
                templateUrl: '/app/STRUMENTI/issueLog/modal/issueLogAddMultiplo.html?version=127',
                controller: 'issueLogAddMultiplo',
                backdrop: 'static',
                resolve: {
                    tMisuraCode: function () {
                        return null;
                    },
                    tRuoloCode: function () {
                        return vm.fTRuoloCode;
                    },
                    tSource: function () {
                        return [vm.tSource];
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    tSourceCode: function () {
                        return vm.tSourceCode_def;
                    },
                    sources: function () {
                        return [];
                    },
                    iRole: function () {
                        return 3; //Il destinatario � l'APL
                    },
                    showDtScad: function () {
                        return true;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                logSuccess('Success! ');
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        }

        function addIssueLog(item, bResp, iRole) {
            switch (iRole) {
                case 1: //Anomalia da CPI all'APL 
                    if (!vm.record.bPresaIncaricoCPI)
                        return bDialog.errorDialog('Per poter aggiungere un\'anomalia \xE8 necessario che la pratica sia stata presa in carico.');
                    break;
                case 2: //Anomalia da UMC al CPI 
                    if (!vm.record.bPresaIncarico)
                        return bDialog.errorDialog('Per poter aggiungere un\'anomalia \xE8 necessario che la pratica sia stata presa in carico.');
                    break;
                case 3: //Anomalia da UMC all'APL 
                    if (!vm.record.bPresaIncarico)
                        return bDialog.errorDialog('Per poter aggiungere un\'anomalia \xE8 necessario che la pratica sia stata presa in carico.');
                    break;
            }

            if (!(vm.isUMC || vm.isSUPER || vm.isFAM)) {
                return bDialog.errorDialog('Azione non autorizzata.');
            }


            var tSource = { Id: vm.tSource.Id, Name: vm.tSource.Name };
            var source = { Id: vm.record.Id, Name: 'ID: ' + vm.record.Id + ' - ' + vm.record.CodiceRicevuta + ' del ' + moment(vm.record.DtRicevuta).format('DD/MM/YYYY') };
            console.info('tSource', tSource);

            var modalInstance = modal.open({
                templateUrl: '/app/STRUMENTI/issueLog/modal/issueLogAdd.html?version=127',
                controller: 'issueLogAdd',
                backdrop: 'static',
                resolve: {
                    tMisuraCode: function () {
                        return vm.fTMisuraCode;
                    },
                    tRuoloCode: function () {
                        return vm.fTRuoloCode;
                    },
                    tSource: function () {
                        return [tSource];
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    source: function () {
                        return [source];
                    },
                    sourceId: function () {
                        return vm.record.Id;
                    },
                    tDestId: function () {
                        switch (iRole) {
                            case 1:
                            case 3:
                                return 2; //il destinatario � l'APL
                            case 2:
                                return 1; //il destinatario � il CPI
                        }
                    },
                    dest: function () {
                        switch (iRole) {
                            case 1:
                            case 3:
                                return vm.record.APL; //il destinatario � l'APL
                            case 2:
                                return vm.record.CPI; //il destinatario � il CPI
                        }
                    },
                    destId: function () {
                        switch (iRole) {
                            case 1:
                            case 3:
                                return vm.record.APLId; //il destinatario � l'APL
                            case 2:
                                return vm.record.CPIId; //il destinatario � il CPI
                        }
                    },
                    bResponse: function () {
                        return bResp;
                    },
                    iRole: function () {
                        return iRole;
                    },
                    issueLog: function () {
                        return item;
                    },
                    bozza: function () {
                        return true;
                    },
                    showDtScad: function () {
                        return vm.showDtScad;
                    },
                    attachId: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "409") return bDialog.errorDialog('errore di creazione! ');

                logSuccess('Dato salvato con successo! ');

                switch (iRole) {
                    case 1: //Anomalia da CPI all'APL 
                        return getListIssuesLog(vm.record.Id, vm.record.APLId, iRole);
                    case 2: //Anomalia da UMC al CPI 
                        return getListIssuesLog(vm.record.Id, vm.record.CPIId, iRole);
                    case 3: //Anomalia da UMC all'APL 
                        return getListIssuesLog(vm.record.Id, vm.record.APLId, iRole);
                }
            }, function () {
                //
            });

        }

        function getListIssuesLog(sourceId, destId, iRole) {
            if (!sourceId || !destId) return;
            switch (iRole) {
                case 1: //Anomalia da CPI all'APL 
                    return getArrayIssues(sourceId, destId, iRole).then(function (data) {
                        return vm.list.issueCPILog = data;
                    });
                case 2: //Anomalia da UMC al CPI 
                    return getArrayIssues(sourceId, destId, iRole).then(function (data) {
                        return vm.list.issueUMCLog = data;
                    });
                case 3: //Anomalia da UMC all'APL 
                    return getArrayIssues(sourceId, destId, iRole).then(function (data) {
                        //console.info('list.issueLog', data);
                        return vm.list.issueLog = data;
                    });
            }
        }

        function getArrayIssues(sourceId, destId, iRole) {
            var iState = -2; //Tutte
            return datacontext.issueLog_getAll(0, 0, '', 0, sourceId, 0, destId, 0, iState, iRole, '').then(function (data) {
                //console.info('getArrayIssues', data);
                return data;
            });
        }

        function setIState(item, iState, iRole) {
            if (!item) return;
            var tmpIState = item.iState;

            var msg = '';
            switch (iState) {
                case 0:
                    msg = 'Si sta "trasmettendo" l\'anomalia. Procedere? ';
                    break;
                case 2:
                    msg = 'Si sta "risolvendo" l\'anomalia. Procedere? ';
                    break;
                case 3:
                    msg = 'Si sta "rifiutando" di risolvere l\'anomalia; per proseguire \xE8 necessario fornire una motivazione. Procedere?';
                    break;
                default: // metti in lavorazione
                    return fn_setIState(item, iState, iRole);
            }

            bDialog.confirmationDialog('Attenzione', msg, 'Prosegui').then(
                function () { //YES
                    if (iState == 3) { //"Non risolvi"
                        addIssueLog(item, true, iRole);
                    }
                    else {
                        mergeItem(1).then(function (data) {
                            fn_setIState(item, iState, iRole);
                        });

                    }
                },
                function () { //NO
                    item.iState = tmpIState;
                    return;
                }
            );
        }

        function fn_setIState(issue, iState, iRole) {
            return datacontext.issueLog_setState(issue.Id, iState).then(function (data) {
                if (data == "400") return bDialog.errorDialog('Errore generico.');
                if (data == "409") return bDialog.errorDialog('Errore modifica dati.');

                issue.iState = iState;
                switch (iRole) {
                    case 1: //Anomalia da CPI all'APL 
                        var index2 = vm.list.issueCPILog.indexOf(issue);
                        vm.list.issueCPILog[index2] = data;
                        break;
                    case 2: //Anomalia da UMC al CPI 
                        var index = vm.list.issueUMCLog.indexOf(issue);
                        vm.list.issueUMCLog[index] = data;
                        break;
                    case 3: //Anomalia da UMC all'APL 
                        var index = vm.list.issueLog.indexOf(issue);
                        vm.list.issueLog[index] = data;
                        break;
                }

                logSuccess('Record Salvato ');
                //getRecord(vm.record.Id);
            });
        }

        function deleteIssueLog(item, iRole) {
            //var Index = index;
            var msg = ' Anomalia: ' + item.Description;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.issueLog_delete(item.Id).then(function (data) {
                    if (data != "204") return bDialog.errorDialog('Errore cancellazione dati [' + data + ']');

                    switch (iRole) {
                        case 1: //Anomalia all'APL da CPI
                            var index = vm.list.issueCPILog.indexOf(item);
                            vm.list.issueCPILog.splice(index, 1);
                            break;
                        case 2: //Anomalia al CPI da UMC
                            var index = vm.list.issueUMCLog.indexOf(item);
                            vm.list.issueUMCLog.splice(index, 1);
                            break;
                        case 3: //Anomalia all'APL da UMC
                            var index = vm.list.issueLog.indexOf(item);
                            vm.list.issueLog.splice(index, 1);
                            break;
                    }

                });
            });
        }


        //STAMPA ANOMALIE
        function printAnomalie(elem) {
            if (elem) { //se esitono anomalie
                var mywindow = window.open('', 'PRINT', 'height=400,width=600');

                mywindow.document.write('<html><head><title>' + document.title + '</title>');
                mywindow.document.write('</head><body >');
                mywindow.document.write('<h1>Fascicolo Anomalie</h1>');
                mywindow.document.write('<h3>Richiesta di indennit&agrave; Id:' + elem[0].SourceId + ' ' + elem[0].Source + '</h3>');
                //mywindow.document.write(document.getElementById(elem).innerHTML);
                mywindow.document.write('<table><tr><td width="10%"><span style="font-weight:bold">Stato</span></td><td width="5%"><span style="font-weight:bold">Id</span></td><td width="15%"><span style="font-weight:bold">Data</span></td><td width="70%"><span style="font-weight:bold">Descrizione</span></td></tr>');

                for (var i = 0; i < elem.length; i++) {
                    if (elem[i].Description == null) elem[i].Description = "";
                    if (elem[i].Response == null) elem[i].Response = "";
                    var anno = elem[i].DtInsert.toString().substring(0, 4);
                    var mese = elem[i].DtInsert.toString().substring(5, 7);
                    var giorno = elem[i].DtInsert.toString().substring(8, 10);

                    var stato = "";
                    switch (elem[i].iState) {
                        case -1:
                            stato = "bozza";
                            break;
                        case 0:
                            stato = "Anom. trasmessa all'APL";
                            break;
                        case 1:
                            stato = "Anom. in lavorazione";
                            break;
                        case 2:
                            stato = "Anom. risolta";
                            break;
                        case 3:
                            stato = "Anom. non risolta";
                            break;

                        default:
                    }
                    mywindow.document.write('<tr>' + '<td style="vertical-align: top">' + stato + '</td>' + '<td style="vertical-align: top">' + elem[i].Id + '</td>' + '<td style="vertical-align: top">' + giorno + "/" + mese + "/" + anno + '</td>' + '<td style="vertical-align: top">' + elem[i].Description + '</td></tr>');
                    if (elem[i].Response != "") {
                        mywindow.document.write('<tr>' + '<td colspan="3">&nbsp;</td><td><span style="font-weight:bold">Motivazione</span></td></tr>');
                        mywindow.document.write('<tr>' + '<td colspan="3">&nbsp;</td><td>' + elem[i].Response + '</td></tr>');
                    }
                    mywindow.document.write('<tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr>');
                }
                mywindow.document.write('</table>');
                mywindow.document.write('</body></html>');
                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus(); // necessary for IE >= 10*/

                mywindow.print();
                mywindow.close();
                return true;
            }
        }
        //------------------------------FINE ANOMALIE-------------------------------------------------------

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID FIELDS CODICE FISCALE -#-#-#-#-#-#
        vm.validFieldsCF = true;
        vm.checkFieldsCF = function () {
            vm.validFieldsCF = true;
            if (vm.record.L_CodiceFiscale == undefined) return;
            if (vm.record.L_CodiceFiscale.length != 16) return; //numero minimo di caratteri
            if (vm.record.L_Nome == undefined) return;
            if (vm.record.L_Cognome == undefined) return;
            if (vm.record.L_Sesso == undefined) return;
            if (vm.record.L_NascPaeseId == 0 && (vm.record.L_NascComuneId == undefined || vm.record.L_NascComuneId == 0)) return;
            if (vm.record.L_DtNasc == undefined || vm.record.L_DtNasc == '') return;
            var strDtNasc = common.dateToString(vm.record.L_DtNasc); //la data deve avere formato dd/MM/yyyy            
            vm.validFieldsCF = false;
            return datacontext.validazione_fieldsCF(vm.record.L_CodiceFiscale, vm.record.L_Nome, vm.record.L_Cognome, vm.record.L_Sesso, strDtNasc, vm.record.L_NascPaeseId, vm.record.L_NascComuneId).then(function (data) {
                return vm.validFieldsCF = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID IBAN -#-#-#-#-#-#
        vm.validIBAN = true;
        vm.checkIBAN = function () {
            console.log('vm.checkIBAN()');
            vm.validIBAN = true;
            if (vm.record.IBAN == undefined) return;
            if (vm.record.IBAN == '') return;
            if (vm.record.IBAN.length != 27) return; //numero minimo di caratteri
            vm.validIBAN = false;
            return datacontext.validazione_iban(vm.record.IBAN).then(function (data) {
                console.info('vm.validIBAN', data);
                return vm.validIBAN = data;
            });
        };

        //TAB VERTICALI
        function setTabShow() {
            console.log('setTabShow()');

            vm.tabInfo = new Array();
            vm.tabAttach = new Array();
            vm.tabIssue = new Array();
            vm.tabGestione = new Array();

            //Info
            var posInfo = 0;
            if (true) //RAPPRESENTANTE LEGALE
            { vm.tabInfo.push({ show: 1, class: 'badge badge-info tools' + posInfo++ }); } else { vm.tabInfo.push({ show: 0, class: '' }); }
            if (true) //SEDE LEGALE
            { vm.tabInfo.push({ show: 1, class: 'badge badge-info tools' + posInfo++ }); } else { vm.tabInfo.push({ show: 0, class: '' }); }
            if (vm.record.TRuoloCode == 'AZD_PROM-LAV1' || vm.record.TRuoloCode == 'AZD_PROM-FAM1' || vm.record.TRuoloCode == 'AZD_FORM-FAM1' || vm.record.TRuoloCode == 'AZD_FORM-LAV1' && vm.record.FORM_Type == 'B') //SEDI
            { vm.tabInfo.push({ show: 1, class: 'badge badge-info tools' + posInfo++ }); } else { vm.tabInfo.push({ show: 0, class: '' }); }
            if (vm.record.TRuoloCode == 'AZD_PROM-FAM1' && vm.record.FAM1_TAziendaId > 1) //PARTNER
            { vm.tabInfo.push({ show: 1, class: 'badge badge-info tools' + posInfo++ }); } else { vm.tabInfo.push({ show: 0, class: '' }); }
            if (vm.record.TRuoloCode == 'AZD_PROM-FAM1' && vm.record.FAM1_TAziendaId > 1) //BUDGET
            { vm.tabInfo.push({ show: 1, class: 'badge badge-info tools' + posInfo++ }); } else { vm.tabInfo.push({ show: 0, class: '' }); }
            if (vm.record.TRuoloCode == 'AZD_FORM-LAV1') //IBAN
            { vm.tabInfo.push({ show: 1, class: 'badge badge-info tools' + posInfo++ }); } else { vm.tabInfo.push({ show: 0, class: '' }); }
            if (vm.record.TRuoloCode == 'AZD_FORM-FAM1' || (vm.record.TRuoloCode == 'AZD_FORM-LAV1' && vm.record.FORM_Type == 'A')) //MODULI FORMATIVI
            { vm.tabInfo.push({ show: 1, class: 'badge badge-info tools' + posInfo++ }); } else { vm.tabInfo.push({ show: 0, class: '' }); }
            if (vm.record.TRuoloCode == 'AZD_FORM-FAM1') //REFERENTE
            { vm.tabInfo.push({ show: 1, class: 'badge badge-info tools' + posInfo++ }); } else { vm.tabInfo.push({ show: 0, class: '' }); }
            if (vm.record.TRuoloCode == 'AZD_FORM-LAV1' && vm.record.FORM_Type == 'A') //AZIENDA
            { vm.tabInfo.push({ show: 1, class: 'badge badge-info tools' + posInfo++ }); } else { vm.tabInfo.push({ show: 0, class: '' }); }
            var tabInfoIndex = 0;
            vm.tabInfo.forEach(function (data) {
                if (data.show == 1) {
                    //if (tabInfoIndex == 2)
                    //    return vm.getPartSedi(vm.record.Id);
                    //if (tabInfoIndex == 3)
                    //    return vm.getPartAziende();
                    //if (tabInfoIndex == 4)
                    //    return vm.getPBudget();
                    //if (tabInfoIndex == 6)
                    //    return vm.getPartModulo();
                }
                tabInfoIndex++;
            });

            //Gestione
            var posGestione = 0;
            if (vm.record.Sent && vm.isSpecial) //SEDI ACCREDITATE
            { vm.tabGestione.push({ show: 1, class: 'badge badge-info tools' + posGestione++ }); } else { vm.tabGestione.push({ show: 0, class: '' }); }
            if (vm.isSUPER) //DATI ISTANZA
            { vm.tabGestione.push({ show: 1, class: 'badge badge-info tools' + posGestione++ }); } else { vm.tabGestione.push({ show: 0, class: '' }); }            
            var tabGestioneIndex = 0;
            vm.tabGestione.forEach(function (data) {
                if (data.show == 1) {
                    //if (tabGestioneIndex == 1)
                    //    return vm.getSediAccr();
                }
                tabGestioneIndex++;
            });

            //Fascicolo Attach
            var posAttach = 0;
            if (vm.record.Completed) //ALLEGATI
            { vm.tabAttach.push({ show: 1, class: 'badge badge-info tools' + posAttach++ }); } else { vm.tabAttach.push({ show: 0, class: '' }); }

            var tabAttachIndex = 0;
            vm.tabAttach.forEach(function (data) {
                if (data.show == 1) {
                    if (tabAttachIndex == 0)
                        return vm.getListAttach(vm.record.Id);
                }
                tabAttachIndex++;
            });

            //Issue
            var posIssue = 0;
            if (vm.ableIssue && vm.record.Sent) //ANOMALIE
            { vm.tabIssue.push({ show: 1, class: 'badge badge-info tools' + posIssue++ }); } else { vm.tabIssue.push({ show: 0, class: '' }); }
            if (false && vm.ableIssue && (vm.isSpecial || vm.isCPI || vm.isAPL)) //ANOMALIE CPI
            { vm.tabIssue.push({ show: 1, class: 'badge badge-info tools' + posIssue++ }); } else { vm.tabIssue.push({ show: 0, class: '' }); }
            if (false && vm.ableIssue && (vm.isSpecial || vm.isCPI)) //ANOMALIE UMC
            { vm.tabIssue.push({ show: 1, class: 'badge badge-info tools' + posIssue++ }); } else { vm.tabIssue.push({ show: 0, class: '' }); }

            var tabIssueIndex = 0;
            vm.tabIssue.forEach(function (data) {
                if (data.show == 1) {
                    if (tabIssueIndex == 0)
                        return getListIssuesLog(vm.record.Id, vm.record.SoggettoId, 3);
                    if (tabIssueIndex == 1)
                        return getListIssuesLog(vm.record.Id, vm.record.SoggettoId, 1);
                    if (tabIssueIndex == 2)
                        return getListIssuesLog(vm.record.Id, vm.record.CPIId, 2);
                }
                tabIssueIndex++;
            });
        }


    }
})();
